import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../Companies/Companies.css";
import Header from "../Header/Header";
import SidebarFilter from "../Companies/SidebarFilter";
import { FaLinkedin } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import { VscPass } from "react-icons/vsc";
import { VscError } from "react-icons/vsc";
import * as XLSX from "xlsx";
import { IoMdDownload } from "react-icons/io";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { GiCampfire } from "react-icons/gi";
import { CiEdit } from "react-icons/ci";
import idea1 from "../../assets/Images/revenue_logo.jpg";
import { IoIosExpand } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { MdOutlineMailOutline } from "react-icons/md";
import Swal from "sweetalert2";
import { IoLockOpen } from "react-icons/io5";
import EmptyImage from "../../assets/Images/no-image.png";
import { IoMdMail } from "react-icons/io";
import html2canvas from "html2canvas";
import line from "../../assets/Images/Line 30.png";
import key from "../../assets/Images/vecteezy_decision-making-icon-design_14631856 [Converted] 1.png";
import job from "../../assets/Images/Group.png";
import { useLocation } from "react-router-dom";
import { IoMdLink } from "react-icons/io";
import mail from "../../assets/Images/mail.png";
import download from "../../assets/Images/download.png";
import cross from "../../assets/Images/cross.png";
import { FaUserTie } from "react-icons/fa";
import { FaClipboardList } from "react-icons/fa6";
import { fetchUserData, fetchCombinedUserData } from "../../api/index";
import { useResearcher } from "../../context/ResearcherContext";
import Not_Verified from "../../assets/Images/NotVerified.png";
import Verified from "../../assets/Images/Verified.png";
import Expiring from "../../assets/Images/Expiring.png";
// import { fetchResearcherDetails} from "../../api/index";

const requiredHeaders = [
  "First name",
  "Company Name",
  "Email",
  "Linkedin",
  "Designation",
  "Phone Number",
  "Website",
  "City",
  "State",
  "Country",
  "Industry",
  "Company Description",
  "Followers",
  "Technology Details",
  "Annual Revenue",
  "No of Employees",
  "Company Location",
  "Headquarter",
  "Sub Category",
  "Type of Customer",
  "Financial",
  "Investors",
  "Job Openings",
  "News and Social insights",
  "Competitors",
  "Partners",
  "Status"
];

const MyContacts = () => {
  const baseURL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

  //open add details popup
  const [isAdd, setIsAdd] = useState(false);

  //for post details
  const [details, setDetails] = useState({
    firstname: "",
    companyname: "",
    linkedin: "",
    email: "",
    designation: "",
    phonenumber: "",
    image: "",
    website: "",
    city: "",
    state: "",
    country: "",
    annualrevenue: "",
    noofemployees: "",
    companylocation: "",
    industry: "",
    headquarter: "",
    subcategory: "",
    typeofCustomer: "",
    companydescription: "",
    technologydetails: "",
    jobopenings: [{ jobname: "", jobdescription: "", jobsource: "" }],
    newsandsocialinsights: [
      { newsname: "", newsdescription: "", newssource: "" },
    ],
    financial: [
      { financialdescription: "", financialsourcelink: "", financialyear: "" },
    ],
    investors: [{ investors: "", investorsourcelink: "" }],
    competitors: "",
    partners: "",
  });

  const navigate = useNavigate();

  const [selectedFilters, setSelectedFilters] = useState({
    mycontacts: [],
    companyname: [],
    industry: [],
    status: [],
    designation: [],
    noofemployees: [],
    companylocation: [],
    annualrevenue: [],
    subcategory: [],
    updatedAt: [],
  });

  //store details in the state
  const [data, setData] = useState([]);
  const [researcherData, setResearcherData] = useState([]);
  const [research, setResearch] = useState([]);
  const [requestedData, setRequestedData] = useState([]);
  const [deletedIds, setDeletedIds] = useState([]);

  //count peoples
  const [count, setCount] = useState(0);
  const [selectedUserId, setSelectedUserId] = useState(null);

  //Profile popup
  const [isOpenProfile, setIsOpenProfile] = useState(false);

  //for search data
  const [searchData, setSearchData] = useState("");

  //table pagination
  const [currentPage, setCurrentPage] = useState(1);

  //expand selected profile
  const [selectedItem, setSelectedItem] = useState(null);

  //show company details
  const [showCompany, setShowCompany] = useState(true);

  //show job openings
  const [showOpenings, setShowOpenings] = useState(false);
  const [showTechstack, setShowTechstack] = useState(false);
  const [showAccount, setShowAccount] = useState(false);
  const [showContact, setShowContact] = useState(false);

  //change background color on click
  const [companyColor, setCompanyColor] = useState("#FCB124");
  const [jobColor, setJobColor] = useState("");
  const [techColor, setTechColor] = useState("");
  const [contactColor, setContactColor] = useState("");
  const [accountColor, setAccountColor] = useState("");
  const [visibleNews, setVisibleNews] = useState(3);

  // const [isDownload, setIsDownload] = useState(false);
  // const [fileType, setFileType] = useState('');

  const [uploadFile, setUploadFile] = useState(null);
  const [excelHeaders, setExcelHeaders] = useState([]);
  const [selectedFields, setSelectedFields] = useState({});
  const [showPopup, setShowPopup] = useState(false);

  const [editMode, setEditMode] = useState(false);

  const [visibleColumns, setVisibleColumns] = useState({});

  //select checkbox for download file
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState();

  const [showMissingFieldsPopup, setShowMissingFieldsPopup] = useState(false);
  const [missingFields, setMissingFields] = useState([]);

  const [isMyContacts, setIsMyContacts] = useState(false);
  const [isContacts, setIsContacts] = useState(true);

  const [role, setRole] = useState("");
  const [file, setFile] = useState(null);

  const [editRequest, setEditRequest] = useState([]);

  //credits count
  const [credits, setCredits] = useState(0);
  const [spentCredits, setSpentCredits] = useState(0);
  const [remainingCredits, setRemainingCredits] = useState(0);

  const [showForm, setShowForm] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [formData, setFormData] = useState({
    firstname: "",
    companyname: "",
    linkedin: "",
    email: "",
    designation: "",
    phonenumber: "",
    image: "",
    website: "",
    city: "",
    state: "",
    country: "",
    annualrevenue: "",
    noofemployees: "",
    companylocation: "",
    industry: "",
    headquarter: "",
    subcategory: "",
    typeofCustomer: "",
    companydescription: "",
    followers: "",
    technologydetails: "",
    jobopenings: [{ jobname: "", jobdescription: "", jobsource: "" }],
    newsandsocialinsights: [
      { newsname: "", newsdescription: "", newssource: "" },
    ],
    financial: [
      { financialdescription: "", financialsourcelink: "", financialyear: "" },
    ],
    investors: [{ investors: "", investorsourcelink: "" }],
    competitors: "",
    partners: "",
    status: "Pending",
  });

  const [isResearch, setIsResearch] = useState(false);
  const [requests, setRequests] = useState([]);

  const [extraFields, setExtraFields] = useState([{ label: "", value: "" }]);
  const [newFieldLabel, setNewFieldLabel] = useState("");
  const [showLabelInput, setShowLabelInput] = useState(false);
  const [expandedNewsIndex, setExpandedNewsIndex] = useState(null);
  const [expandedJobIndex, setExpandedJobIndex] = useState(null);

  //For table designation
  const [listName, setListName] = useState("");
  const [showlist, setShowlist] = useState(false);
  const [selectedList, setSelectedList] = useState([]);
  const [userlists, setuserlists] = useState(false);
  const [list, setList] = useState([]);
  const [selectedListName, setSelectedListName] = useState(null);
  const [hover, setHover] = useState(false);
  const [scoopHover, setScoopHover] = useState(false);
  const [viewedProfiles, setViewedProfiles] = useState([]);

  const itemsPerPage = 10;
  const chunkSize = 50;

  const [page, setPage] = useState(1);
  const [allDataCount, setAllDataCount] = useState(0);
  const [researcherAllDataCount, setResearcherAllDataCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [researcherTotalCount, setResearcherTotalCount] = useState(0);
  const [filteredData, setFilteredData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  useEffect(() => {
    const userRole = localStorage.getItem("role");
    setRole(userRole);
  }, []);

  const [adminId, setAdminId] = useState(null);

  useEffect(() => {
    const fetchAdminId = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/getadminid`);
        setAdminId(response.data.adminId);
      } catch (err) {
        console.error(
          "Failed to fetch admin ID:",
          err.response?.data?.message || err.message
        );
      }
    };

    fetchAdminId();
  }, []);

  const { researcherId } = useResearcher();

  useEffect(() => {}, [selectedRequest, showForm]);

  useEffect(() => {
    const openId = location.state?.openProfileId;

    if (openId && paginatedData.length > 0) {
      const alreadyViewed = viewedProfiles.includes(openId);

      if (alreadyViewed || role !== "user") {
        const itemToExpand = paginatedData.find((item) => item._id === openId);
        if (itemToExpand) {
          setSelectedItem(itemToExpand);
          setIsOpenProfile(true);
        }
      } else {
        handleOpenProfile(openId);
      }
    }
  }, [location.state, data, viewedProfiles, role]);

  useEffect(() => {
    if (research.extraFields && research.extraFields.length > 0) {
      setExtraFields(research.extraFields);
    } else {
      setExtraFields([]);
    }
  }, [research]);

const sortUsers = (users) => {
  return [...users].sort((a, b) => {
    const getCategory = (user) => {
      const hasScoop =
        user.technologydetails ||
        (user.jobopenings && user.jobopenings.some(
          (item) => item.jobname || item.jobdescription || item.jobsource
        )) ||
        (user.newsandsocialinsights && user.newsandsocialinsights.some(
          (item) => item.newsname || item.newsdescription || item.newssource
        ));

      if (hasScoop && user.status === "Verified" && viewedProfiles.includes(user._id)) {
        return 1; // Scoop Fire + Verified
      }
      if (hasScoop && user.status === "Verified" && !viewedProfiles.includes(user._id)) {
        return 2; // Scoop Lock + Verified
      }
      if (!hasScoop && user.status === "Verified") {
        return 3; // No Scoop + Verified
      }
      return 4; // No Scoop + Not Verified
    };

    return getCategory(a) - getCategory(b);
  });
};

const fetchCombinedData = async (chunkIndex) => {
    setIsLoading(true);
    const skip = chunkIndex * chunkSize;
    const limit = chunkSize;
    const token = localStorage.getItem("token");

  if (!token) {
    console.error("No token found.");
    return;
  }

  try {
    const data = await fetchCombinedUserData(skip, limit, researcherId);

    const chunkData = data?.details || [];
   
    setData((prev) => ({
      ...prev,
      [chunkIndex]: chunkData,
    }));
    if(data.totalCount === 0){
      setIsLoading(false);
    }else{
          setIsLoading(false);

    }
    setAllDataCount(data.totalCount);
    setTotalCount(data.totalCount);
    setCredits(data.subscriptions[0].credits);
    setRemainingCredits(data.subscriptions[0].remainingcredits);
    setSpentCredits(data.subscriptions[0].spentcredits)
    setViewedProfiles(data.viewedProfiles);
    setRequestedData(data.requestedData);
    setDeletedIds(data.deletedIds);
  } catch (error) {
    console.error("Error fetching chunk:", error);
  }
  };

let isFilterApplied = Object.values(selectedFilters).some(
    (arr) => arr.length > 0
  );
  const hasSearch = searchData && searchData.trim().length > 0;

  let paginatedData = [];

  if (isFilterApplied) {
    const allDetails = Array.isArray(filteredData)
      ? filteredData: [];

    let matchingDetails = allDetails.filter((item) =>
      Object.entries(selectedFilters).every(([key, values]) => {
        if (values.length === 0) return true;

        if (key === "updatedAt") {
          const itemDate = item.updatedAt?.slice(0, 10);
          return values.includes(itemDate);
        }

        return values.includes(item[key]);
      })
    );

    if (hasSearch) {
      const searchTerm = searchData.toLowerCase();
      matchingDetails = matchingDetails.filter((item) =>
        Object.values(item).some((val) =>
          val?.toString().toLowerCase().includes(searchTerm)
        )
      );
      setCurrentPage(1)
      setTotalCount(matchingDetails.length);
    }

    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    paginatedData = matchingDetails.slice(start, end);
  } else {
    const chunkIndex = Math.floor(
      (currentPage - 1) / (chunkSize / itemsPerPage)
    );
    const chunkData = data[chunkIndex] || [];

    let visibleData = chunkData;

    if (hasSearch) {
      const searchTerm = searchData.toLowerCase();
      visibleData = chunkData.filter((item) =>
        Object.values(item).some((val) =>
          val?.toString().toLowerCase().includes(searchTerm)
        )
      );
    }

    const localPage = (currentPage - 1) % (chunkSize / itemsPerPage);
    const start = localPage * itemsPerPage;
    const end = start + itemsPerPage;

    paginatedData = visibleData.slice(start, end);
    
  }

  useEffect(() => {
    const indicesToCheck = [
      Math.floor((currentPage - 1) / (chunkSize / itemsPerPage)),
      Math.floor(page / (chunkSize / itemsPerPage)),
    ];

    indicesToCheck.forEach((chunkIndex) => {
      if (researcherId) {
        if (!data[chunkIndex]) {
          fetchCombinedData(chunkIndex);
        }
      }
    });
  }, [currentPage, page, chunkSize, itemsPerPage, data, researcherId, requestedData]);

  useEffect(() => {
    let result = [];

    if (isFilterApplied) {
      const allDetails = Array.isArray(filteredData)
        ? filteredData.flatMap((item) => item.details || [])
        : [];

      result = allDetails.filter((item) =>
        Object.entries(selectedFilters).every(([key, values]) => {
          if (values.length === 0) return true;
          if (key === "updatedAt") {
            const itemDate = item.updatedAt?.slice(0, 10);
            return values.includes(itemDate);
          }
          return values.includes(item[key]);
        })
      );

      if (hasSearch) {
        const term = searchData.toLowerCase();
        result = result.filter((item) =>
          Object.values(item).some((val) =>
            val?.toString().toLowerCase().includes(term)
          )
        );
        setTotalCount(result.length);
      }
    } else {
      const chunkIndex = Math.floor(
        (currentPage - 1) / (chunkSize / itemsPerPage)
      );
      const chunkData = data[chunkIndex] || [];

      result = hasSearch
        ? chunkData.filter((item) =>
            Object.values(item).some((val) =>
              val?.toString().toLowerCase().includes(searchData.toLowerCase())
            )
          )
        : chunkData;
      setTotalCount(allDataCount);
    }
  }, [filteredData, selectedFilters, searchData, data, currentPage]);

  // useEffect(() => {
  //   const chunkIndex = Math.floor((currentPage - 1) / (chunkSize / itemsPerPage));
  //   if(researcherId){
  //      if (!data[chunkIndex]) {
  //     fetchResearcher(chunkIndex);
  //   }
  //   }

  // }, [researcherId, currentPage]);

  // useEffect(() => {
  //   const prefetchIndex = Math.floor(page / (chunkSize / itemsPerPage));
  //   if(researcherId){
  //     if (!data[prefetchIndex]) {
  //     fetchResearcher(prefetchIndex);
  //   }
  //   }
  // }, [page]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleCloseOverlay = () => {
    if (isAdd) {
      setIsAdd(false);
    } else if (editMode) {
      setEditMode(false);
    }
    setSelectedRows([]);
    setDetails({
      firstname: "",
      companyname: "",
      linkedin: "",
      email: "",
      designation: "",
      phonenumber: "",
      website: "",
      city: "",
      state: "",
      country: "",
      annualrevenue: "",
      noofemployees: "",
      companylocation: "",
      industry: "",
      headquarter: "",
      subcategory: "",
      typeofCustomer: "",
      companydescription: "",
      technologydetails: "",
      jobopenings: [{ jobname: "", jobdescription: "", jobsource: "" }],
      newsandsocialinsights: [
        { newsname: "", newsdescription: "", newssource: "" },
      ],
      financial: [
        {
          financialdescription: "",
          financialsourcelink: "",
          financialyear: "",
        },
      ],
      investors: [{ investors: "", investorsourcelink: "" }],
      competitors: "",
      partners: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const userName = localStorage.getItem("name");
    const userEmail = localStorage.getItem("email");

    if (!token) {
      Swal.fire({
        icon: "error",
        title: "error",
        text: "You need to login first",
      });
      return navigate("/");
    }

    try {
      const apiUrl = `${baseURL}/api/user`;

      let response;

      const requestBody = {
        updatedDetails: details,
        userId,
        userName,
        userEmail,
        researcherId,
      };

      if (editMode) {
        response = await axios.put(
          `${apiUrl}/update/${details._id}`,
          requestBody,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        response = await axios.post(apiUrl, details, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
      }
      if (editMode) {
        Swal.fire({
          icon: "success",
          title: "Contact updated successfully",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
      } else {
        console.log("Contact added successfully");
        Swal.fire({
          icon: "success",
          title: "Contact added successfully",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
      }
      // Reset Form
      setDetails({
        firstname: "",
        companyname: "",
        linkedin: "",
        email: "",
        designation: "",
        phonenumber: "",
        website: "",
        city: "",
        state: "",
        country: "",
        annualrevenue: "",
        noofemployees: "",
        companylocation: "",
        industry: "",
        headquarter: "",
        subcategory: "",
        typeofCustomer: "",
        companydescription: "",
        technologydetails: "",
        jobopenings: [{ jobname: "", jobdescription: "", jobsource: "" }],
        newsandsocialinsights: [
          { newsname: "", newsdescription: "", newssource: "" },
        ],
        financial: [
          {
            financialdescription: "",
            financialsourcelink: "",
            financialyear: "",
          },
        ],
        investors: [{ investors: "", investorsourcelink: "" }],
        competitors: "",
        partners: "",
        ...(editMode && { updatedAt: new Date() }),
      });
      setIsAdd(false);
      setEditMode(false);
      setSelectedRows([]);
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Internal Server Error",
        text: "Error",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  const handleFinanceChange = (e, index, field) => {
    const newFinancialDetails = [...details.financial];
    newFinancialDetails[index][field] = e.target.value;
    setDetails({ ...details, financial: newFinancialDetails });
  };

  const addFinancial = () => {
    setDetails({
      ...details,
      financial: [
        ...details.financial,
        { financialdescription: "", financesourcelink: "", financialyear: "" },
      ],
    });
  };

  const removeFinancial = (index) => {
    const newFinancialDetails = details.financial.filter((_, i) => i !== index);
    setDetails({ ...details, financial: newFinancialDetails });
  };

  const handleInvestorChange = (e, index, field) => {
    const newInvestorDetails = [...details.investors];
    newInvestorDetails[index][field] = e.target.value;
    setDetails({ ...details, investors: newInvestorDetails });
  };

  const addInvestor = () => {
    setDetails({
      ...details,
      investors: [
        ...details.investors,
        { investors: "", investorsourcelink: "" },
      ],
    });
  };

  const removeInvestor = (index) => {
    const newInvestorDetails = details.investors.filter((_, i) => i !== index);
    setDetails({ ...details, investors: newInvestorDetails });
  };

  const handleJobChange = (e, index, field) => {
    const newJobOpenings = [...details.jobopenings];
    newJobOpenings[index][field] = e.target.value;
    setDetails({ ...details, jobopenings: newJobOpenings });
  };

  const addJobOpening = () => {
    setDetails({
      ...details,
      jobopenings: [
        ...details.jobopenings,
        { jobname: "", jobdescription: "", jobsource: "" },
      ],
    });
  };

  const removeJobOpening = (index) => {
    const newJobOpenings = details.jobopenings.filter((_, i) => i !== index);
    setDetails({ ...details, jobopenings: newJobOpenings });
  };

  const handleNewsChange = (e, index, field) => {
    const newNews = [...details.newsandsocialinsights];
    newNews[index][field] = e.target.value;
    setDetails({ ...details, newsandsocialinsights: newNews });
  };

  const addNews = () => {
    setDetails({
      ...details,
      newsandsocialinsights: [
        ...details.newsandsocialinsights,
        { newsname: "", newsdescription: "", newssource: "" },
      ],
    });
  };

  const removeNews = (index) => {
    const newNews = details.newsandsocialinsights.filter((_, i) => i !== index);
    setDetails({ ...details, newsandsocialinsights: newNews });
  };

  const handleFinanceFormChange = (e, index, field) => {
    const newFinancialDetails = [...formData.financial];
    newFinancialDetails[index][field] = e.target.value;
    setFormData({ ...formData, financial: newFinancialDetails });
  };

  const addFinancialForm = () => {
    setFormData({
      ...formData,
      financial: [
        ...formData.financial,
        { financialdescription: "", financesourcelink: "", financialyear: "" },
      ],
    });
  };

  const removeFinancialForm = (index) => {
    const newFinancialDetails = formData.financial.filter(
      (_, i) => i !== index
    );
    setFormData({ ...formData, financial: newFinancialDetails });
  };

  const handleInvestorFormChange = (e, index, field) => {
    const newInvestorDetails = [...formData.investors];
    newInvestorDetails[index][field] = e.target.value;
    setFormData({ ...formData, investors: newInvestorDetails });
  };

  const addInvestorForm = () => {
    setFormData({
      ...formData,
      investors: [
        ...formData.investors,
        { investors: "", investorsourcelink: "" },
      ],
    });
  };

  const removeInvestorForm = (index) => {
    const newInvestorDetails = formData.investors.filter((_, i) => i !== index);
    setFormData({ ...formData, investors: newInvestorDetails });
  };

  const handleJobFormChange = (e, index, field) => {
    const newJobOpenings = [...formData.jobopenings];
    newJobOpenings[index][field] = e.target.value;
    setFormData({ ...formData, jobopenings: newJobOpenings });
  };

  const addJobOpeningForm = () => {
    setFormData({
      ...formData,
      jobopenings: [
        ...formData.jobopenings,
        { jobname: "", jobdescription: "", jobsource: "" },
      ],
    });
  };

  const removeJobOpeningForm = (index) => {
    const newJobOpenings = formData.jobopenings.filter((_, i) => i !== index);
    setFormData({ ...formData, jobopenings: newJobOpenings });
  };

  const handleNewsFormChange = (e, index, field) => {
    const newNews = [...formData.newsandsocialinsights];
    newNews[index][field] = e.target.value;
    setFormData({ ...formData, newsandsocialinsights: newNews });
  };

  const addNewsForm = () => {
    setFormData({
      ...formData,
      newsandsocialinsights: [
        ...formData.newsandsocialinsights,
        { newsname: "", newsdescription: "", newssource: "" },
      ],
    });
  };

  const removeNewsForm = (index) => {
    const newNews = formData.newsandsocialinsights.filter(
      (_, i) => i !== index
    );
    setFormData({ ...formData, newsandsocialinsights: newNews });
  };

  const handleShowMoreNews = () => {
    setVisibleNews((prev) => prev + 3);
  };

  const saveCreditsToDB = async (credits, spentcredits, remainingcredits) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${baseURL}/api/update-credits/${userId}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ credits, spentcredits, remainingcredits }),
      });

      const data = await response.json();
    } catch (error) {
      console.error("Error saving credits:", error);
    }
  };

  const handleOpenProfile = async (id, user) => {
  if (remainingCredits === 0) {
    Swal.fire({
      icon: "warning",
      title: "No Remaining Credits",
      confirmButtonColor: "#FCB124",
      confirmButtonText: "OK",
    });
    return;
  }

  if (role === "user") {
  if (!viewedProfiles.includes(id)) {
    await pushResearcherContact({ ...user, researcherId });
    await markProfileAsViewed(id);
  }
}


  const itemToExpand = paginatedData.find((item) => item._id === id);
  if (itemToExpand) {
    setSelectedItem(itemToExpand);
    setIsOpenProfile(true);
  }
};


const pushResearcherContact = async (user) => {
  const token = localStorage.getItem("token");
  if (!token) return;

  const payload = {
    researcherId: user.researcherId || user.userid,
    selectedUserIds: [user._id],
  };

  try {
    const res = await fetch(`${baseURL}/api/pushtolist`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();
    if (!res.ok) {
      console.error("Push failed:", data.message);
    } else {
      console.log("Push success:", data.message);

      setResearcherData((prev) => {
        const updated = { ...prev };
        Object.keys(updated).forEach((chunkIndex) => {
          updated[chunkIndex] = updated[chunkIndex].map((c) =>
            c._id === user._id
              ? { ...c, updatedByRole: "user" } 
              : c
          );
        });
        return updated;
      });

      setData((prev) => {
        const updated = { ...prev };
        Object.keys(updated).forEach((chunkIndex) => {
          updated[chunkIndex] = updated[chunkIndex].map((c) =>
            c._id === user._id
              ? { ...c, updatedByRole: "user" }
              : c
          );
        });
        return updated;
      });
    }
  } catch (err) {
    console.error("Error pushing researcher contact:", err);
  }
};

const markProfileAsViewed = async (id) => {
  const updatedViewed = [...viewedProfiles, id];
  const updatedSpent = spentCredits + 1;
  const updatedRemaining = remainingCredits - 1;

  setSpentCredits(updatedSpent);
  setRemainingCredits(updatedRemaining);
  setViewedProfiles(updatedViewed);

  const token = localStorage.getItem("token");
  await axios.put(
    `${baseURL}/api/viewed-profiles`,
    { profileId: id },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  saveCreditsToDB(credits, updatedSpent, updatedRemaining);
};

  const totalPages = Math.ceil(totalCount / itemsPerPage);

  useEffect(() => {
    if (!paginatedData.length) return;

    const columnsVisibility = Object.keys(paginatedData[0]).reduce(
      (acc, key) => {
        acc[key] = paginatedData.some((item) => item[key]);
        return acc;
      },
      {}
    );

    setVisibleColumns((prevColumns) =>
      JSON.stringify(prevColumns) !== JSON.stringify(columnsVisibility)
        ? columnsVisibility
        : prevColumns
    );
  }, [paginatedData]);

  const isEnabled = viewedProfiles.includes(selectedUserId);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  const handleEdit = (id) => {
    if (!viewedProfiles.includes(id)) {
      Swal.fire({
        icon: "warning",
        title: "Access Denied",
        text: "You must view the scoop before editing.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      setSelectedRows([]);
      return;
    }

    const itemToEdit = paginatedData.find((item) => item._id === id);
    if (itemToEdit) {
      setDetails(itemToEdit);
      setEditMode(true);
      setIsAdd(false);
    }
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    if (selectedRows.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Selection",
        text: "Please select at least one entry to delete.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    const deleteUrl = `${baseURL}/api/delete-details`;
    try {
      const response = await fetch(deleteUrl, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ids: selectedRows }),
      });

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Contacts deleted Successfully",
          confirmButtonColor: "#FCB124",
        });
        setData((prevData) =>
          Array.isArray(prevData)
            ? prevData.filter((item) => !selectedRows.includes(item._id))
            : []
        );
        setSelectedRows([]);
        setSelectAll();
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed to delete contact(s)",
          confirmButtonColor: "FCB124",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Something went wrong!",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  const handleShowCompany = () => {
    setCompanyColor("#FCB124");
    setContactColor("#fff");
    setJobColor("#fff");
    setTechColor("#fff");
    setAccountColor("#fff");
    setShowCompany(true);
    setShowTechstack(false);
    setShowAccount(false);
    setShowContact(false);
    setShowOpenings(false);
  };

  const handleShowTechStack = () => {
    setCompanyColor("#fff");
    setTechColor("#FCB124");
    setContactColor("#fff");
    setJobColor("#fff");
    setAccountColor("#fff");
    setShowTechstack(true);
    setShowAccount(false);
    setShowCompany(false);
    setShowContact(false);
    setShowOpenings(false);
  };

  const handleShowContact = () => {
    setContactColor("#FCB124");
    setCompanyColor("#fff");
    setTechColor("#fff");
    setJobColor("#fff");
    setAccountColor("#fff");
    setShowCompany(false);
    setShowAccount(false);
    setShowTechstack(false);
    setShowContact(true);
    setShowOpenings(false);
  };

  const handleShowAccount = () => {
    setContactColor("#fff");
    setCompanyColor("#fff");
    setTechColor("#fff");
    setJobColor("#fff");
    setAccountColor("#FCB124");
    setShowAccount(true);
    setShowCompany(false);
    setShowTechstack(false);
    setShowContact(false);
    setShowOpenings(false);
  };

  const handleCloseProfile = () => {
    setIsOpenProfile(false);
  };

  const getStatusprofile = (status) => {
    return status === "Active"
      ? "status-active-profile"
      : "status-inactive-profile";
  };

  const handleShowOpenings = (e) => {
    e.stopPropagation();
    setJobColor("#FCB124");
    setCompanyColor("#fff");
    setContactColor("#fff");
    setAccountColor("#fff");
    setTechColor("#fff");
    setShowAccount(false);
    setShowCompany(false);
    setShowContact(false);
    setShowTechstack(false);
    setShowOpenings(true);
  };

  const downloadPDF = (companyId) => {
    if (!companyId) {
      alert("No company selected for download!");
      return;
    }

    const selectedCompany = paginatedData.find(
      (item) => item._id === companyId
    );
    if (!selectedCompany) {
      alert("Company not found!");
      return;
    }

    const doc = new jsPDF();
    let y = 10;

    const checkPageSpace = (extraHeight = 10) => {
      if (y + extraHeight > 270) {
        doc.addPage();
        y = 10;
      }
    };

    const addTextBlock = (label, text) => {
      doc.setFont("Times New Roman", "bold");
      doc.text(label, 14, y);
      y += 5;
      doc.setFont("Times New Roman", "normal");
      const lines = doc.splitTextToSize(text || "N/A", 180);
      checkPageSpace(lines.length * 7);
      doc.text(lines, 14, y);
      y += lines.length * 7;
    };

    // 1️⃣ Title
    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(16);
    doc.text("Company Profile Report", 14, y);
    y += 10;

    // 2️⃣ Company Information
    doc.setFontSize(12);
    doc.setFont("Times New Roman", "normal");
    doc.text(`Company Name: ${selectedCompany.companyname || "N/A"}`, 14, y);
    y += 10;
    doc.text(`Website: ${selectedCompany.website || "N/A"}`, 14, y);
    y += 10;

    addTextBlock("Headquarter:", selectedCompany.headquarter);

    // 3️⃣ Business Description
    addTextBlock("Business Description:", selectedCompany.companydescription);

    // 4️⃣ Industry Details
    checkPageSpace(40);
    doc.setFont("Times New Roman", "bold");
    doc.text("Industry Details", 14, y);
    y += 5;
    doc.autoTable({
      startY: y,
      head: [["Category", "Value"]],
      body: [
        ["Industry", selectedCompany.industry || "N/A"],
        ["Annual Revenue", selectedCompany.annualrevenue || "N/A"],
        ["No. of Employees", selectedCompany.noofemployees || "N/A"],
        ["Type of Customer", selectedCompany.typeofcustomer || "N/A"],
      ],
    });
    y = doc.autoTable.previous.finalY + 10;

    // 5️⃣ Financial Information
    doc.setFont("Times New Roman", "bold");
    doc.text("Financial Information", 14, y);
    y += 5;
    doc.setFont("Times New Roman", "normal");

    let splitFinance = doc.splitTextToSize(
      selectedCompany.financial?.financialdescription || "N/A",
      180
    );
    checkPageSpace(splitFinance.length * 7);
    doc.text(splitFinance, 14, y);
    y += splitFinance.length * 7;

    doc.text(
      `Financial Source: ${
        selectedCompany.financial?.financialsourcelink || "N/A"
      }`,
      14,
      y
    );
    y += 10;

    doc.text(
      `Financial Year: ${selectedCompany.financial?.financialyear || "N/A"}`,
      14,
      y
    );
    y += 10;

    doc.autoTable({
      startY: y,
      head: [["Metric", "Value"]],
      body: [
        ["Investors", selectedCompany.investors?.investors || "N/A"],
        [
          "Investor Description",
          selectedCompany.investors?.investordescription || "N/A",
        ],
      ],
    });
    y = doc.autoTable.previous.finalY + 10;

    // 6️⃣ Technology Details
    doc.setFont("Times New Roman", "bold");
    doc.text("Technology Details:", 14, y);
    y += 5;
    doc.setFont("Times New Roman", "normal");

    const techDetails = selectedCompany.technologydetails || "N/A";
    const techLines = doc.splitTextToSize(techDetails, 180);
    checkPageSpace(techLines.length * 7);
    doc.text(techLines, 14, y);
    y += techLines.length * 7;

    // 7️⃣ Job Openings
    doc.setFont("Times New Roman", "bold");
    doc.text("Job Openings", 14, y);
    y += 5;
    doc.setFont("Times New Roman", "normal");

    doc.text(`Job Title: ${selectedCompany.job?.jobname || "N/A"}`, 14, y);
    y += 10;

    const jobDescLines = doc.splitTextToSize(
      selectedCompany.job?.jobdescription || "N/A",
      180
    );
    doc.text("Job Description:", 14, y);
    y += 5;
    doc.text(jobDescLines, 14, y);
    y += jobDescLines.length * 7;

    checkPageSpace(10);
    doc.text(`Job Link: ${selectedCompany.job?.jobsource || "N/A"}`, 14, y);

    // 8️⃣ Save PDF
    doc.save(`${selectedCompany.companyname}_Profile.pdf`);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];

    if (!allowedTypes.includes(file.type)) {
      alert("Please upload a valid Excel file (.xlsx or .xls)!");
      return;
    }

    setUploadFile(file);
    setSelectedFields({});
  };

  // Handle file upload
  const handleUpload = async () => {
    if (!uploadFile) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please select a file first!",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      let headers = jsonData[0] || [];

      // Ensure headers are strings, trimmed, and converted to lowercase
      headers = headers.map((header) =>
        header ? header.toString().trim() : ""
      );

      if (headers.length === 0) {
        alert("The uploaded file is empty or does not contain headers.");
        return;
      }

      setExcelHeaders(headers);
      setShowPopup(true);
    };

    reader.readAsArrayBuffer(uploadFile);
  };

  // Handle field mapping
  const handleMappingChange = (uploadedHeader, selectedValue) => {
    setSelectedFields((prevMapping) => {
      const updatedMapping = { ...prevMapping };

      if (selectedValue) {
        updatedMapping[uploadedHeader] = selectedValue;
      } else {
        delete updatedMapping[uploadedHeader];
      }

      return updatedMapping;
    });
  };

  // Function to Cancel Upload
  const handleCancelUpload = () => {
    setShowMissingFieldsPopup(false);
  };

  const handleProceedUpload = async (e) => {
    e.preventDefault();
    setShowMissingFieldsPopup(false);
    const token = localStorage.getItem("token");

    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Authentication Error",
        text: "You need to log in again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    if (!uploadFile) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please select a file first!",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    const reader = new FileReader();
    reader.readAsBinaryString(uploadFile);

    reader.onloadend = async (e) => {
      try {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        let jsonData = XLSX.utils.sheet_to_json(worksheet);

        if (jsonData.length === 0) {
          Swal.fire({
            icon: "error",
            title: "Empty File",
            text: "The uploaded file is empty!",
          });
          return;
        }

        const formattedData = jsonData.map((row) => ({
          firstname: row["First Name"]?.trim() || "",
          companyname: row["Company Name"]?.trim() || "",
          linkedin: row["LinkedIn"]?.trim() || "",
          email: row["Email"]?.trim() || "",
          designation: row["Designation"]?.trim() || "",
          phonenumber: row["Phone Number"]?.trim() || "",
          website: row["Website"]?.trim() || "",
          city: row["City"]?.trim() || "",
          state: row["State"]?.trim() || "",
          country: row["Country"]?.trim() || "",
          annualrevenue: row["Annual Revenue"]?.trim() || "",
          noofemployees: row["No of Employees"] || "",
          companylocation: row["Company Location"]?.trim() || "",
          industry: row["Industry"]?.trim() || "",
          headquarter: row["Headquarter"]?.trim() || "",
          subcategory: row["Subcategory"]?.trim() || "",
          typeofcustomer: row["Type of Customer"]?.trim() || "",
          companydescription: row["Company Description"]?.trim() || "",
          followers: row["Followers"] || "",
          technologydetails: row[" Technology Details"]?.trim() || "",
          competitors: row["Competitors"]?.trim() || "",
          partners: row["Partners"]?.trim() || "",
          jobopenings: row["Job Openings"]
            ? parseExcelDetails(row["Job Openings"], "jobopenings")
            : [],
          newsandsocialinsights: row["News and Social Insights"]
            ? parseExcelDetails(
                row["News and Social Insights"],
                "newsandsocialinsights"
              )
            : [],
          financial: row["Financial"]
            ? parseExcelDetails(row["Financial"], "financial")
            : [],
          investors: row["Investors"]
            ? parseExcelDetails(row["Investors"], "investors")
            : [],
        }));

        const formData = new FormData();
        formData.append("file", uploadFile);
        formData.append("data", JSON.stringify(formattedData));
        formData.append("selectedFields", JSON.stringify(selectedFields));
        formData.append("confirmUpload", true);
        formData.append("researcherId", researcherId);
        formData.append("listName", selectedListName);

        const uploadUrl = `${baseURL}/api/upload-excel`;

        const response = await fetch(uploadUrl, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        });

        const responseData = await response.json();

        if (response.ok) {
          Swal.fire({
            icon: "success",
            title: "Upload Successful",
            text: responseData.message || "File uploaded successfully.",
          });

          if (
            responseData.insertedData &&
            Array.isArray(responseData.insertedData)
          ) {
            
        
            fetchCombinedData(0);
          }
        } else {
          Swal.fire({
            icon: "warning",
            title: "Upload Failed",
            text: responseData.error || "An error occurred during upload.",
          });
        }
        setUploadFile(null);
      } catch (err) {
        console.error("Upload error:", err);
        Swal.fire({
          icon: "error",
          title: "Upload Error",
          text: "An unexpected error occurred.",
        });
      }
    };
  };

  const parseExcelDetails = (dataString, type) => {
    if (!dataString || typeof dataString !== "string") return [];

    return dataString
      .replace(/^\[|\]$/g, "")
      .split(/\],\s*\[/)
      .map((entry) => {
        const parts = entry.split(" | ").map((part) => {
          const trimmedPart = part.trim();
          return trimmedPart.toLowerCase() === "null" || trimmedPart === ""
            ? ""
            : trimmedPart;
        });

        let parsedEntry = {};

        switch (type) {
          case "jobopenings":
            parsedEntry = {
              jobname: parts[0] || "",
              jobdescription: parts[1] || "",
              jobsource: parts[2] || "",
            };
            break;
          case "newsandsocialinsights":
            parsedEntry = {
              newsname: parts[0] || "",
              newsdescription: parts[1] || "",
              newssource: parts[2] || "",
            };
            break;
          case "financial":
            parsedEntry = {
              financialdescription: parts[0] || "",
              financialsourcelink: parts[1] || "",
              financialyear: parts[2] || "",
            };
            break;
          case "investors":
            parsedEntry = {
              investors: parts[0] || "",
              investorsourcelink: parts[1] || "",
            };
            break;
          default:
            console.warn(`Unknown type: ${type}`);
            parsedEntry = { error: `Invalid type: ${type}` };
            break;
        }

        return parsedEntry;
      });
  };

  const handleCheckMissingFields = async () => {
    if (!uploadFile) {
      console.error("🚨 No file selected");
      alert("Please select a file before uploading.");
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Authentication Error",
        text: "You need to log in again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("selectedFields", JSON.stringify(selectedFields));

    const uploadUrl = `${baseURL}/api/upload-excel`;

    try {
      const previewResponse = await fetch(uploadUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const previewData = await previewResponse.json();

      if (previewData.missingFields && previewData.missingFields.length > 0) {
        setMissingFields(previewData.missingFields);
        setShowMissingFieldsPopup(true);
        setShowPopup(false);
      } else {
        handleUpload(true);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error Checking Missing Fields",
        text: "An error occurred while checking for missing fields. Please try again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  const handleDetail = (id) => {
    navigate(`/companypage/${id}`, { state: { from: "my-contacts" } });
  };

  const handleOpenEmailCampaign = (id) => {
    navigate(`/campaign/${id}`, {
      state: { fromContacts: true, openProfileId: id },
    });
  };

  const handleCheckboxChange = (id) => {
        setSelectedRows((prevSelected) => {
        console.log(selectedRows);
      const isAlreadySelected = prevSelected.includes(id);

      const newSelected = isAlreadySelected
        ? prevSelected.filter((i) => i !== id)
        : [...prevSelected, id];

      setSelectedUserId(
        newSelected.length > 0 ? newSelected[newSelected.length - 1] : null
      );

      return newSelected;
    });
  };

  const handleSelectAll = () => {
    if (selectAll) {
      // Deselect all
      setSelectedRows([]);
    } else {
      // Select all visible/paginated rows
      setSelectedRows(paginatedData.map((user) => user._id));
    }

    setSelectAll(!selectAll); // Toggle the selectAll state
  };

  const handleDownloadExcel = () => {
    if (selectedRows.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Selection Required!",
        text: "Please select at least one row to download.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Ok",
      });
      return;
    }

    const unviewedIds = selectedRows.filter(
      (id) => !viewedProfiles.includes(id)
    );
    if (unviewedIds.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Access Denied",
        text: "You can only download scoops you’ve already unlocked.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Ok",
      });
      setSelectedRows([]);
      setSelectAll();
      return;
    }

    // Define expected headers
    const expectedHeaders = [
      "firstname",
      "companyname",
      "linkedin",
      "email",
      "designation",
      "phonenumber",
      "website",
      "city",
      "state",
      "country",
      "annualrevenue",
      "noofemployees",
      "companylocation",
      "industry",
      "headquarter",
      "subcategory",
      "typeofCustomer",
      "companydescription",
      "followers",
      "technologydetails",
      "jobopenings",
      "newsandsocialinsights",
      "financial",
      "investors",
      "competitors",
      "partner",
    ];

    // Filter selected data from paginatedData
    const selectedData = paginatedData.filter((row) =>
      selectedRows.includes(row._id)
    );
    if (selectedData.length === 0) {
      Swal.fire({
        icon: "error",
        title: "No Data",
        text: "No valid data found for download.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    // Format array fields like jobopenings, etc.
    const formatArrayField = (dataArray, fieldNames) => {
      if (!Array.isArray(dataArray) || dataArray.length === 0) return "";
      return dataArray
        .map(
          (item) =>
            `[${fieldNames.map((field) => item[field] || "").join(" | ")}]`
        )
        .join(", ");
    };

    // Format data according to headers
    const formattedData = selectedData.map((row) =>
      expectedHeaders.reduce((formattedRow, header) => {
        const arrayFieldMappings = {
          jobopenings: ["jobname", "jobdescription", "jobsource"],
          newsandsocialinsights: ["newsname", "newsdescription", "newssource"],
          financial: [
            "financialdescription",
            "financialsourcelink",
            "financialyear",
          ],
          investors: ["investors", "investorsourcelink"],
        };

        if (arrayFieldMappings[header]) {
          formattedRow[header] = formatArrayField(
            row[header],
            arrayFieldMappings[header]
          );
        } else {
          formattedRow[header] = row[header] || "";
        }

        return formattedRow;
      }, {})
    );

    try {
      const worksheet = XLSX.utils.json_to_sheet(formattedData, {
        header: expectedHeaders,
      });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Data");
      XLSX.writeFile(workbook, "SelectedData.xlsx");

      Swal.fire({
        icon: "success",
        title: "Download Successful",
        text: "File downloaded successfully!",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });

      setSelectedRows([]);
      setSelectAll();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: "Failed to download the Excel file. Please try again later.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      setSelectedRows([]);
      setSelectAll();
    }
  };

  const handleDownloadAllData = async () => {
    const allUserIds = data.map((user) => user._id);

    if (role === "user") {
      const missingIds = allUserIds.filter(
        (id) => !viewedProfiles.includes(id)
      );

      if (missingIds.length > 0) {
        Swal.fire({
          icon: "warning",
          title: "Incomplete Access",
          text: "You must unlock all scoops before downloading the full data.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "Ok",
        });
        return;
      }
    }

    try {
      const token = localStorage.getItem("token");

      const response = await fetch(`${baseURL}/api/download-excel`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "UserData.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      Swal.fire({
        icon: "success",
        title: "Download Complete!",
        text: "Your file has been downloaded successfully.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Ok",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error Downloading File",
        text: "There was a problem downloading the file. Please try again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  const handleDisplayMyContacts = () => {
    setSearchData("");
    setIsMyContacts(true);
    setIsContacts(false);
    setuserlists(false);
    setSelectedRows([]);
    setSelectAll();
  };

  const handleDisplayContacts = () => {
    setSearchData("");
    setIsMyContacts(false);
    setIsContacts(true);
    setuserlists(false);
    setSelectedRows([]);
    setSelectAll();
  };

  const handleDisplayUserLists = () => {
    setuserlists(true);
    setIsContacts(false);
    setIsMyContacts(false);
    setSearchData("");
    setSelectedRows([]);
    setSelectAll();
  };

  const handleRequestData = async (item) => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const userName = localStorage.getItem("name");
    const userEmail = localStorage.getItem("email");

    if (!token) {
      Swal.fire({
        icon: "warning",
        title: "Access Denied",
        text: "You must log in first!",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    const id = item._id;
    const updatedViewed = [...requestedData, id];
    setRequestedData(updatedViewed);

    const missingFields = {};
    const availableFields = {};
    const checkFields = [
      "technologydetails",
      "jobopenings",
      "newsandsocialinsights",
      "financial",
      "investors",
    ];

    checkFields.forEach((field) => {
      const value = item[field];
      const isEmpty =
        value === undefined ||
        value === null ||
        (typeof value === "string" && value.trim() === "") ||
        (Array.isArray(value) && value.length === 0);

      if (isEmpty) {
        missingFields[field] = field === "technologydetails" ? "" : [];
      } else {
        availableFields[field] = value;
      }
    });

    if (Object.keys(missingFields).length === 0) {
      Swal.fire({
        icon: "success",
        title: "All mandatory fields are available.",
        text: "No request needed.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Okay",
      });
      return;
    }

    const requestData = {
      researcherId,
      adminId,
      userId,
      userName,
      userEmail,
      matchId: item._id,
      firstname: item.firstname || "",
      companyname: item.companyname || "",
      linkedin: item.linkedin || "",
      email: item.email || "",
      designation: item.designation || "",
      phonenumber: item.phonenumber || "",
      website: item.website || "",
      city: item.city || "",
      state: item.state || "",
      country: item.country || "",
      annualrevenue: item.annualrevenue || "",
      noofemployees: item.noofemployees || "",
      companylocation: item.companylocation || "",
      industry: item.industry || "",
      headquarter: item.headquarter || "",
      subcategory: item.subcategory || "",
      typeofCustomer: item.typeofCustomer || "",
      companydescription: item.companydescription || "",
      technologydetails: item.technologydetails || "",
      jobopenings: item.jobopenings || [],
      newsandsocialinsights: item.newsandsocialinsights || [],
      financial: item.financial || [],
      investors: item.investors || [],
      competitors: item.competitors || "",
      partners: item.partners || "",
      status: item.status || "Pending",
      createdAt: item.createdAt || new Date().toISOString(),
      filePath: item.filePath || "",
      availableFields,
      missingFields,
    };

    try {
      const [putResponse, postResponse] = await Promise.all([
        axios.put(
          `${baseURL}/api/requested-data`,
          { profileId: id },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        ),
        fetch(`${baseURL}/api/send-request`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestData),
        }),
      ]);

      const result = await postResponse.json();
      fetchCombinedData();
    } catch (error) {
      console.error("Error sending request:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to Send Request",
        text: "There was a problem sending your request. Please try again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  const handleBulkRequestData = async () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const userName = localStorage.getItem("name");
    const userEmail = localStorage.getItem("email");

    if (!token) {
      Swal.fire({
        icon: "warning",
        title: "Access Denied",
        text: "You must log in first!",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }
    if (remainingCredits === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Remaining Credits",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    if (!paginatedData || paginatedData.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No data available for selection",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Okay",
      });
      return;
    }

    if (selectedRows.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Please select at least one contact to send a request.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Ok",
      });
      return;
    }

    // Fields to check
    const requiredFields = [
      "technologydetails",
      "jobopenings",
      "newsandsocialinsights",
    ];

    // Prepare bulk request data
    const requestList = selectedRows
      .map((id) => {
        const item = paginatedData.find((company) => company._id === id);
        if (!item) {
          console.warn(
            `Invalid selection: ID ${id} not found in paginatedData.`
          );
          return null;
        }

        // Ensure fields are arrays or set them to empty arrays if undefined
        requiredFields.forEach((field) => {
          if (!Array.isArray(item[field])) {
            item[field] = [];
          }
        });

        // Check if at least one required field is missing
        const isDataMissing = requiredFields.some(
          (field) => item[field].length === 0
        );

        if (!isDataMissing) {
          console.warn(
            `Skipping ${item.companyname}: Some required data already exists.`
          );
          return null;
        }

        return {
          userId: item._id,
          firstname: item.firstname || "",
          companyname: item.companyname || "",
          linkedin: item.linkedin || "",
          email: item.email || "",
          designation: item.designation || "",
          phonenumber: item.phonenumber || "",
          website: item.website || "",
          city: item.city || "",
          state: item.state || "",
          country: item.country || "",
          annualrevenue: item.annualrevenue || "",
          noofemployees: item.noofemployees || "",
          companylocation: item.companylocation || "",
          industry: item.industry || "",
          headquarter: item.headquarter || "",
          subcategory: item.subcategory || "",
          typeofCustomer: item.typeofCustomer || "",
          companydescription: item.companydescription || "",
          technologydetails: item.technologydetails || [],
          jobopenings: item.jobopenings || [],
          newsandsocialinsights: item.newsandsocialinsights || [],
          financial: item.financial || [],
          investors: item.investors || [],
          competitors: item.competitors || "",
          partners: item.partners || "",
          requestedFields: requiredFields,
        };
      })
      .filter(Boolean);

    if (requestList.length === 0) {
      Swal.fire({
        icon: "info",
        title: "No Requests Sent",
        text: "All selected companies already have Technology Details, Job Openings, and News & Insights.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    const requestedIds = requestList.map((req) => req.userId);

    const updatedViewed = [...requestedData, requestedIds];

    setRequestedData(updatedViewed);
    try {
      const [putResponse, postResponse] = await Promise.all([
        // Send all requested IDs to the DB
        axios.put(
          `${baseURL}/api/requested-data`,
          { profileIds: requestedIds },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        ),
        // Send bulk request payload
        fetch(`${baseURL}/api/send-bulk-request`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            adminId,
            researcherId,
            userId,
            userName,
            userEmail,
            requests: requestList,
          }),
        }),
      ]);

      const result = await postResponse.json();

      if (postResponse.ok) {
        Swal.fire({
          icon: "success",
          title: "Request Sent",
          text: result.message || "Bulk request sent successfully.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
        fetchCombinedData();
        setSelectedRows([]);
        setSelectAll();
      } else if (putResponse.ok) {
        Swal.fire({
          icon: "success",
          title: "Request Sent",
          text: result.message || "Bulk request sent successfully.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
        fetchCombinedData();
        setSelectedRows([]);
        setSelectAll();
      } else {
        Swal.fire({
          icon: "error",
          title: "Request Failed",
          text: result.message || "Failed to send bulk request.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error sending bulk request:", error);
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Please try again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  // Update form data when admin fills input
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmitDetails = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    if (!token) {
      Swal.fire({
        icon: "warning",
        title: "You need to login first",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    if (!selectedRequest || !selectedRequest._id) {
      alert("No request selected!");
      return;
    }

    try {
      const response = await fetch(
        `${baseURL}/api/update-single-request/${selectedRequest._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            requestedFields: formData,
            status: "Submitted",
          }),
        }
      );

      const result = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Request updated successfully!",
          confirmButtonColor: "FCB124",
          confirmButtonText: "Ok",
        });
        setFormData(
          result.updatedAdmin.singleRequests.find(
            (req) => req._id === selectedRequest._id
          )
        );
        setShowForm(false);
      } else {
        alert("Failed to update request: " + result.error);
      }
    } catch (error) {
      console.error("Error updating request:", error);
      alert("Error updating request");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setResearch((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handlelist = () => {
    if (selectedRows.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Selection",
        text: "Please select at least one user before creating a list.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }
    setShowlist(true);
  };

  const handleSave = async () => {
    if (!selectedRows.length) {
      Swal.fire({
        icon: "warning",
        title: "No Selection",
        text: "Please select at least one user.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      Swal.fire({
        icon: "warning",
        title: "You need to login first",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      // Fetch existing lists to determine the next available list name
      const response = await fetch(`${baseURL}/api/get-lists`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch existing lists");
      }

      const existingLists = await response.json();
      let finalListName = listName.trim();

      if (!finalListName) {
        let listCount = 1;

        if (existingLists.lists && Array.isArray(existingLists.lists)) {
          listCount = existingLists.lists.length + 1;
        }

        finalListName = `List ${listCount}`;
      }

      // Extract user data for selected rows
      const selectedUsers = selectedRows.map((id) =>
        paginatedData.find((user) => user._id === id)
      );

      const payload = {
        listName: finalListName,
        users: selectedUsers.map((user) => ({
          userid: user._id,
          firstname: user.firstname || "N/A",
          companyname: user.companyname || "N/A",
          email: user.email || "N/A",
          linkedin: user.linkedin || "",
          designation: user.designation || "",
          phonenumber: user.phonenumber || "",
          website: user.website || "",
          city: user.city || "",
          state: user.state || "",
          country: user.country || "",
          annualrevenue: user.annualrevenue || "",
          noofemployees: user.noofemployees || "",
          companylocation: user.companylocation || "",
          industry: user.industry || "",
          headquarter: user.headquarter || "",
          subcategory: user.subcategory || "",
          typeofCustomer: user.typeofCustomer || "",
          companydescription: user.companydescription || "",
          technologydetails: Array.isArray(user.technologydetails)
            ? user.technologydetails.join(", ")
            : user.technologydetails || "",
          jobopenings: Array.isArray(user.jobopenings) ? user.jobopenings : [],
          newsandsocialinsights: Array.isArray(user.newsandsocialinsights)
            ? user.newsandsocialinsights
            : [],
          financial: Array.isArray(user.financial) ? user.financial : [],
          investors: Array.isArray(user.investors) ? user.investors : [],
          competitors: user.competitors || "",
          partners: user.partners || "",
        })),
      };

      const saveResponse = await fetch(`${baseURL}/api/add-list`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const saveData = await saveResponse.json();
      if (saveResponse.ok) {
        Swal.fire({
          icon: "success",
          title: "List Created Successfully!",
          text: "Your new list has been created.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "Ok",
        });
        setList((prevLists) => [...prevLists, payload]);
        setShowlist(false);
        setListName("");
        setSelectedRows([]);
        setSelectAll();
      } else {
        alert(saveData.message || "Failed to create the list.");
      }
    } catch (error) {
      console.error("Error creating list:", error);
      alert("Error occurred while creating the list.");
    }
  };

  const handleOpenResearch = async (id) => {
    if (selectedRows.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Please select one row!",
        text: "Please select only one row for research.",
        confirmButtonColor: "#FCB124",
      });
      return;
    }

    if (selectedRows.length > 1) {
      Swal.fire({
        icon: "warning",
        title: "Only one row allowed!",
        text: "Please select only one row for research.",
        confirmButtonColor: "#FCB124",
      });
      return;
    }

    if (remainingCredits === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Remaining Credits",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      const response = await fetch(`${baseURL}/api/user/${id}`);
      const data = await response.json();

      const allFieldsFilled =
        data.extraFields &&
        data.extraFields.length > 0 &&
        data.extraFields.every(
          (field) => field.value && field.value.trim() !== ""
        );

      if (
        allFieldsFilled ||
        (data.extraFields && data.extraFields.length > 0)
      ) {
        const result = await Swal.fire({
          title: allFieldsFilled
            ? "Research Request Completed"
            : "Research Request In Progress",
          text: "You already sent a research request. Do you want to modify it or add a new one?",
          icon: allFieldsFilled ? "info" : "warning",
          showCancelButton: true,
          confirmButtonText: "Modify",
          cancelButtonText: "New Request",
        });

        if (result.isConfirmed) {
          Swal.fire({
            icon: "info",
            title: "Modifications Restricted",
            text: "Modifications are restricted. Please contact the support team.",
            confirmButtonColor: "#FCB124",
          });
        } else {
          setResearch({ ...data });
          setIsResearch(true);
        }
      } else {
        setResearch({ ...data });
        setIsResearch(true);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
    setSelectedRows([]);
  };

  const handleFieldValueChange = (e, index) => {
    const { value } = e.target;
    setResearch((prevResearch) => {
      const updatedExtraFields = prevResearch.extraFields
        ? [...prevResearch.extraFields]
        : [];

      if (updatedExtraFields[index]) {
        updatedExtraFields[index].value = value;
      }

      return {
        ...prevResearch,
        extraFields: updatedExtraFields,
      };
    });
  };

  const handleLabelSubmit = async (e) => {
    if (e.key === "Enter" && newFieldLabel.trim()) {
      const updatedFields = research.extraFields?.length
        ? [...research.extraFields, { label: newFieldLabel, value: "" }]
        : [{ label: newFieldLabel, value: "" }];

      setResearch((prev) => ({
        ...prev,
        extraFields: updatedFields,
      }));

      setNewFieldLabel("");
      setShowLabelInput(false);

      // ✅ Save to backend with userid
      try {
        const token = localStorage.getItem("token");
        if (isMyContacts) {
          await axios.put(
            `${baseURL}/api/update-research/${research._id}`,
            { extraFields: updatedFields },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
        } else if (userlists) {
          await axios.put(
            `${baseURL}/api/update-research/${listName}/${research._id}`,
            { extraFields: updatedFields },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
        }
      } catch (error) {
        console.error("Error updating extra fields:", error);
        alert("Failed to save extra fields.");
      }
    }
  };

  const handleSendResearch = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const userName = localStorage.getItem("name");
    const userEmail = localStorage.getItem("email");

    if (!token) {
      Swal.fire({
        icon: "warning",
        title: "Access Denied",
        text: "You must log in first!",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    const requestData = {
      ...research,
      researcherId,
      userId,
      userName,
      userEmail,
      matchId: research?._id || null,
    };

    try {
      const response = await fetch(`${baseURL}/api/research-data`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestData),
      });

      const responseData = await response.json();

      if (response.ok) {
        setResearch(responseData);
        setIsResearch(false);
        setSelectedRows([]);
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Research data sent successfully.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
        if (remainingCredits > 0) {
          const updatedSpent = spentCredits + 1;
          const updatedRemaining = remainingCredits - 1;

          setSpentCredits(updatedSpent);
          setRemainingCredits(updatedRemaining);

          saveCreditsToDB(credits, updatedSpent, updatedRemaining);
        } else {
          Swal.fire({
            icon: "warning",
            title: "No Remaining Credits",
            confirmButtonColor: "#FCB124",
            confirmButtonText: "OK",
          });
        }
      } else {
        throw new Error(
          responseData.message || "Failed to send research data."
        );
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Something went wrong. Please try again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      console.error("Request failed:", error);
    }
  };

  const handleSubmitResearch = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    if (!token) {
      Swal.fire({
        icon: "error",
        title: "You must log in first.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Ok",
      });
      return;
    }

    try {
      const response = await axios.put(
        `${baseURL}/api/submit-research`,
        {
          userId: research.userId,
          matchId: research.matchId,
          extraFields: extraFields,
          status: "Submitted",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        setResearch(response.data.data);
        Swal.fire({
          icon: "success",
          title: "Extra field updated successfully!",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "Ok",
        });
        setIsResearch(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error occurred while submitting details.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "Ok",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: error.response?.data?.message || "An error occurred.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Ok",
      });
    }
  };

  const handleApproveResearch = async (userId, matchId) => {
    try {
      const response = await fetch(
        `${baseURL}/api/approve-research-request/${userId}/${matchId}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ matchId, status: "Approved", researcherId }),
        }
      );
      const data = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Request Approved Successfully!",
          text: "Request Approved Successfully!",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "Ok",
        });

        setIsResearch(false);
      } else {
        Swal.fire({
          icon: "error",
          title: data.message || "Failed to approve the request.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "Okay",
        });
      }
    } catch (error) {
      console.error("Approval Error:", error);
      Swal.fire({
        icon: "error",
        title: "Something went wrong.",
        text: "Please try again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Ok",
      });
    }
  };

// Helper to check if a user has scoop
const hasScoop = (user) =>
  user.technologydetails ||
  (user.jobopenings &&
    user.jobopenings.some(
      (item) => item.jobname || item.jobdescription || item.jobsource
    )) ||
  (user.newsandsocialinsights &&
    user.newsandsocialinsights.some(
      (item) =>
        item.newsname || item.newsdescription || item.newssource
    ));

  const groupedData = [
  // 1. Scoop + Verified
  ...paginatedData.filter((u) => hasScoop(u) && u.status === "Verified"),
  // 2. Scoop + Not Verified
  ...paginatedData.filter((u) => hasScoop(u) && u.status !== "Verified"),
  // 3. No Scoop + Verified
  ...paginatedData.filter((u) => !hasScoop(u) && u.status === "Verified"),
  // 4. No Scoop + Not Verified
  ...paginatedData.filter((u) => !hasScoop(u) && u.status !== "Verified"),
];

const getImageData = (status) => {
    switch (status) {
      case "Not Verified":
        return { src: Not_Verified, alt: "Not Verified", tooltip: "Not Verified" };
      case "Verified":
        return { src: Verified, alt: "Verified", tooltip: "Verified" };
      case "Expiring":
        return { src: Expiring, alt: "Expiring", tooltip: "Expiring Soon" };
      default:
        return { src: Not_Verified, alt: "Not Verified", tooltip: "Not Verified" };
    }
  };
  return (
    <>
      <div>
        <Header
          setSearchData={setSearchData}
          credits={credits}
          setCredits={setCredits}
          spentCredits={spentCredits}
          setSpentCredits={setSpentCredits}
          remainingCredits={remainingCredits}
          setRemainingCredits={setRemainingCredits}
          saveCreditsToDB={saveCreditsToDB}
          handleOpenProfile={handleOpenProfile}
          isContacts={isContacts}
          setIsContacts={setIsContacts}
          isMyContacts={isMyContacts}
          userlists={userlists}
        />
      </div>
      <div className="companies-container">
        <SidebarFilter
          setSelectedList={setSelectedList}
          selectedList={selectedList}
          selectedListName={selectedListName}
          setSelectedListName={setSelectedListName}
          selectedFilters={selectedFilters}
          setFilteredData={setFilteredData}
          setSelectedFilters={setSelectedFilters}
          isMyContacts={isMyContacts}
          totalCount={totalCount}
          setTotalCount={setTotalCount}
          setIsMyContacts={setIsMyContacts}
          handleDisplayMyContacts={handleDisplayMyContacts}
          handleDisplayUserLists={handleDisplayUserLists}
          userlists={userlists}
          setuserlists={setuserlists}
          setIsContacts={setIsContacts}
          handleDisplayContacts={handleDisplayContacts}
          isContacts={isContacts}
        />
        <div className="companies">
          <div className="companies-top">
            <div className={`people-favorite`}></div>
          </div>
          <div className="companies-count">
            <div className="count">
              <div
                style={role === "user" ? { gap: "50px" } : { gap: "300px" }}
                className="crm-contacts"
              >
                <div className="crm-add-search">
                  <p>
                    {" "}
                    My Contacts &nbsp;
                    <span style={{ fontSize: "24px" }}>{totalCount}</span>
                  </p>
                  <div>
                    <button
                      className="crm-donld"
                      onClick={handleDownloadAllData}
                    >
                      <IoMdDownload />{" "}
                    </button>
                  </div>
                  <div>
                    <button className="create-list-btn" onClick={handlelist}>
                      Create List
                    </button>
                  </div>
                  <div></div>
                </div>
                <div className="crm-add-search">
                  <div>
                    <div className="company-btn">
                      <button
                        style={{
                          width: "100px",
                          height: "30px",
                          borderRadius: "5px",
                          color: "#FCB124",
                        }}
                        onClick={() => handleUpload()}
                      >
                        Bulk Upload
                      </button>
                      <input
                        className="input-upload"
                        type="file"
                        accept=".xlsx, .xls"
                        onChange={handleFileChange}
                      />
                    </div>
                    {uploadFile && (
                      <div className="upload-status">
                        <span style={{ fontSize: "12px" }}>✅</span>
                        <span style={{ fontSize: "12px" }}>
                          Ready to Upload!
                        </span>
                      </div>
                    )}
                  </div>
                  {paginatedData.length > 0 && (
                    <>
                      <div
                        className="crm-search"
                        onClick={() => handleBulkRequestData()}
                      >
                        <p
                          className="scoop-input"
                          style={{
                            fontSize: "14px",
                            color: "#000",
                            width: "110px",
                            cursor: "pointer",
                          }}
                        >
                          Enrich Scoop
                        </p>
                        <img
                          className="search-icon"
                          style={{ width: "20px", height: "15px" }}
                          src={idea1}
                          alt="scoop-img"
                        />
                      </div>
                      <div
                        onClick={() => {
                          if (isEnabled) handleOpenResearch(selectedUserId);
                        }}
                        style={{
                          cursor: isEnabled ? "pointer" : "default",
                          opacity: isEnabled ? 1 : 0.6,
                        }}
                        className="crm-search"
                      >
                        <p
                          className="scoop-input"
                          style={{
                            fontSize: "14px",
                            color: "#000",
                            width: "130px",
                            cursor: isEnabled ? "pointer" : "default",
                          }}
                        >
                          Research for me
                        </p>
                        <img
                          className="search-icon"
                          style={{ width: "20px", height: "15px" }}
                          src={idea1}
                          alt="scoop-img"
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            {isLoading ? (
              <div className="spinner-container">
                <div className="loading-spinner"></div>
                <p style={{ marginTop: "10px", color: "#666" }}>Loading...</p>
              </div>
            ) : paginatedData.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  color: "#aaa",
                  marginTop: "100px",
                }}
              >
                <p>No data found</p>
                <p>Please upload an Excel file containing the data</p>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => (window.location.href = "/sample.xlsx")}
                >
                  <IoMdDownload /> Sample file
                </span>
              </div>
            ) : (
              <>
                <div className="table-icons">
                  <div className="tablepagination">
                    <table className="company-table">
                      <thead>
                        <tr>
                          <th>
                            <input
                              type="checkbox"
                              checked={selectAll}
                              onChange={handleSelectAll}
                            />
                          </th>
                          {visibleColumns.firstname && <th>Name</th>}
                          {visibleColumns.companyname && <th>Company Name</th>}
                          {visibleColumns.designation && <th>Designation</th>}
                          <th>Scoop</th>
                          <th>Status</th>
                          <th>Updated by</th>
                          <th>Last updated</th>
                        </tr>
                      </thead>
                      <tbody>
                        { sortUsers(groupedData).map((user) => {
                          const { src, alt, tooltip } = getImageData(
                            user.status
                          );
                          return (
                            <tr key={user._id}>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={selectedRows.includes(user._id)}
                                  onChange={() =>
                                    handleCheckboxChange(user._id)
                                  }
                                />
                              </td>
                              {visibleColumns.firstname && (
                                <td className="name-linkedin">
                                  <span>
                                    <p>{user.firstname}</p>
                                  </span>
                                  {visibleColumns.linkedin && user.linkedin && (
                                    <a
                                      href={user.linkedin}
                                      target="_blank"
                                      rel="noreferrer noopener"
                                    >
                                      <FaLinkedin
                                        className="linkedin"
                                        style={{ margin: "0px 10px" }}
                                      />
                                    </a>
                                  )}
                                </td>
                              )}
                              {visibleColumns.companyname && (
                                <td
                                  style={{
                                    cursor: !viewedProfiles.includes(user._id)
                                      ? "default"
                                      : "pointer",
                                    position: "relative",
                                  }}
                                  className="expand"
                                >
                                  <span
                                    className="scoop-fire"
                                    style={{ margin: "0px 5px" }}
                                  >
                                    <button
                                      onMouseOver={() => setHover(user._id)}
                                      onMouseLeave={() => setHover(false)}
                                      style={{
                                        cursor: !viewedProfiles.includes(
                                          user._id
                                        )
                                          ? "default"
                                          : "pointer",
                                        color: !viewedProfiles.includes(
                                          user._id
                                        )
                                          ? "#000"
                                          : "#FCB124",
                                      }}
                                      disabled={
                                        !viewedProfiles.includes(user._id)
                                      }
                                      onClick={() =>
                                        handleDetail(
                                          user._id,
                                          user.source,
                                          user.researcherId
                                        )
                                      }
                                    >
                                      {user.companyname
                                        ? user.companyname.length > 20
                                          ? `${user.companyname.slice(
                                              0,
                                              20
                                            )}...`
                                          : user.companyname
                                        : "-"}
                                    </button>
                                    {hover === user._id &&
                                      !viewedProfiles.includes(user._id) && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: "40px",
                                            left: "35%",
                                            transform: "translateX(-50%)",
                                            backgroundColor:
                                              "rgba(0, 0, 0, 0.8)",
                                            color: "white",
                                            padding: "8px",
                                            borderRadius: "6px",
                                            fontSize: "12px",
                                            whiteSpace: "nowrap",
                                            zIndex: 3,
                                          }}
                                        >
                                          Buy scoop
                                        </div>
                                      )}
                                  </span>
                                </td>
                              )}
                              {/* {visibleColumns.email && (
                                <td
                                  style={{
                                    // color: "#0000FF",
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "left",
                                  }}
                                >
                                  <MdOutlineMailOutline
                                    style={{
                                      margin: "0px 5px",
                                      alignItems: "center",
                                      color: "#0000FF",
                                    }}
                                  />
                                  {user.email.length > 20
                                    ? `${user.email.slice(0, 20)}...`
                                    : user.email}
                                </td>
                              )} */}
                              {visibleColumns.designation && (
                                <td>
                                  {user.designation
                                    ? user.designation.length > 20
                                      ? `${user.designation.slice(0, 20)}...`
                                      : user.designation
                                    : "-"}
                                </td>
                              )}

                              <td
                                className="expand"
                                style={{ position: "relative" }}
                              >
                                {(role === "researcher" ||
                                  role === "admin" ||
                                  role === "user") && (
                                  <>
                                    {user.technologydetails ||
                                    (user.jobopenings &&
                                      user.jobopenings.some(
                                        (item) =>
                                          item.jobname ||
                                          item.jobdescription ||
                                          item.jobsource
                                      )) ||
                                    (user.newsandsocialinsights &&
                                      user.newsandsocialinsights.some(
                                        (item) =>
                                          item.newsname ||
                                          item.newsdescription ||
                                          item.newssource
                                      )) ? (
                                      !viewedProfiles.includes(user._id) ? (
                                        <div
                                          onClick={() =>
                                            handleOpenProfile(user._id, user)
                                          }
                                        >
                                          <span
                                            className="scoop-fire-1"
                                            style={{ margin: "0px 5px" }}
                                          >
                                            <IoLockOpen
                                              onMouseOver={() =>
                                                setScoopHover(user._id)
                                              }
                                              onMouseLeave={() =>
                                                setScoopHover(false)
                                              }
                                            />
                                            {scoopHover === user._id && (
                                              <div
                                                style={{
                                                  position: "absolute",
                                                  top: "40px",
                                                  left: "50%",
                                                  transform: "translateX(-50%)",
                                                  backgroundColor:
                                                    "rgba(0, 0, 0, 0.8)",
                                                  color: "white",
                                                  padding: "8px",
                                                  borderRadius: "6px",
                                                  fontSize: "12px",
                                                  whiteSpace: "nowrap",
                                                  zIndex: 100,
                                                }}
                                              >
                                                View scoop
                                              </div>
                                            )}
                                          </span>
                                        </div>
                                      ) : (
                                        <span
                                          className="scoop-fire-1"
                                          style={{ margin: "0px 5px" }}
                                        >
                                          <GiCampfire
                                            onClick={() =>
                                              handleOpenProfile(user._id, user)
                                            }
                                          />
                                        </span>
                                      )
                                    ) : requestedData.includes(user._id) ? (
                                      <span
                                        style={{
                                          margin: "0px 5px",
                                          color: "gray",
                                        }}
                                      >
                                        Requested
                                      </span>
                                    ) : (
                                      <span
                                        onClick={() => handleRequestData(user)}
                                        style={{ margin: "0px 5px" }}
                                      >
                                        <button>Request</button>
                                      </span>
                                    )}
                                  </>
                                )}
                              </td>
                              <td>
                                {user.status === "Not Verified" ? (
                                  <img
                                    src={src}
                                    alt={alt}
                                    title={tooltip}
                                    className="verified-not-expire"
                                  />
                                ) : user.status === "Verified" ? (
                                  <img
                                    src={src}
                                    alt={alt}
                                    title={tooltip}
                                    className="verified-not-expire"
                                  />
                                ) : user.status === "Expiring" ? (
                                  <img
                                    src={src}
                                    alt={alt}
                                    title={tooltip}
                                    className="verified-not-expire"
                                  />
                                ) : (
                                  <img
                                    src={src}
                                    alt={alt}
                                    title={tooltip}
                                    className="verified-not-expire"
                                  />
                                )}
                              </td>
                              <td>
                                {" "}
                                {user.updatedByRole === "user"
                                  ? "You"
                                  : user.updatedByRole === "researcher"
                                  ? "Researcher"
                                  : "You"}
                              </td>
                              <td className="expand">
                                <span
                                  className="scoop-fire"
                                  style={{ margin: "0px 5px" }}
                                >
                                  <button>
                                    {user.updatedAt
                                      ? new Date(user.updatedAt)
                                          .toLocaleDateString("en-GB")
                                          .replace(/\//g, "-")
                                      : "N/A"}
                                  </button>
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <div className="table-pagination">
                      <button
                        className="nav-button"
                        onClick={() => goToPage(currentPage - 1)}
                        disabled={currentPage === 1}
                      >
                        Prev
                      </button>

                      {(() => {
                        const pageButtons = [];
                        const maxVisible = 5;
                        let startPage = Math.max(1, currentPage - 2);
                        let endPage = Math.min(
                          totalPages,
                          startPage + maxVisible - 1
                        );

                        // Adjust startPage if we’re at the end
                        if (endPage - startPage < maxVisible - 1) {
                          startPage = Math.max(1, endPage - maxVisible + 1);
                        }

                        for (let i = startPage; i <= endPage; i++) {
                          pageButtons.push(
                            <button
                              key={i}
                              className={currentPage === i ? "active-page" : ""}
                              onClick={() => goToPage(i)}
                              style={{
                                fontWeight:
                                  currentPage === i ? "bold" : "normal",
                                margin: "5px",
                              }}
                            >
                              {i}
                            </button>
                          );
                        }

                        return pageButtons;
                      })()}

                      {/* Dots if more pages exist */}
                      {currentPage + 2 < totalPages && (
                        <span style={{ margin: "0 10px" }}>...</span>
                      )}

                      <button
                        className="nav-button"
                        onClick={() => goToPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                  <div className="crm-icons">
                    <div className="crm-search">
                      <button
                        className="crm-download"
                        onClick={handleDownloadExcel}
                      >
                        <IoMdDownload />
                      </button>
                    </div>
                    <div className="crm-search">
                      <button
                        className="crm-edit"
                        onClick={() =>
                          selectedUserId && handleEdit(selectedUserId)
                        }
                      >
                        <CiEdit />
                      </button>
                    </div>
                    <div className="crm-search">
                      <button className="crm-delete" onClick={handleDelete}>
                        <MdDelete />
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )}
            {showForm && selectedRequest && (
              <div className="add-popup">
                <div
                  className="overlay"
                  onClick={() => {
                    setShowForm(false);
                  }}
                ></div>
                <div className="add-popup-box">
                  <div className="add-heading">
                    <button
                      className="popup-close"
                      onClick={() => {
                        setShowForm(false);
                      }}
                    >
                      X
                    </button>
                    <h4>Update missing fields</h4>
                  </div>
                  <form
                    className="form-container"
                    onSubmit={handleSubmitDetails}
                  >
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="name">First Name</label>
                        <input
                          type="text"
                          name="firstname"
                          placeholder="Enter name"
                          value={formData.firstname}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="name">Company Name</label>
                        <input
                          type="text"
                          name="companyname"
                          placeholder="Enter company name"
                          value={formData.companyname}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="linkedin">Linkedin Link</label>
                        <input
                          type="text"
                          name="linkedin"
                          placeholder="Enter linkedin link"
                          value={formData.linkedin}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="name">Email</label>
                        <input
                          type="email"
                          name="email"
                          placeholder="Enter email"
                          value={formData.email}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Designation</label>
                        <input
                          type="text"
                          name="designation"
                          placeholder="Designation"
                          value={formData.designation}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Phone Number</label>
                        <input
                          type="number"
                          name="phonenumber"
                          placeholder="Phone Number"
                          value={formData.phonenumber}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="website">Website</label>
                        <input
                          type="text"
                          name="website"
                          placeholder="Website Link"
                          value={formData.website}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="designation">Company description</label>
                        <textarea
                          type="text"
                          name="companydescription"
                          placeholder="Company Description"
                          value={formData.companydescription}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">City</label>
                        <input
                          type="text"
                          name="city"
                          placeholder="City"
                          value={formData.city}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">State</label>
                        <input
                          type="text"
                          name="state"
                          placeholder="State"
                          value={formData.state}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="country">Country</label>
                        <input
                          type="text"
                          name="country"
                          placeholder="Country"
                          value={formData.country}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Industry</label>
                        <input
                          type="text"
                          name="industry"
                          placeholder="Industry"
                          value={formData.industry}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Annual Revenue</label>
                        <input
                          type="text"
                          name="annualrevenue"
                          placeholder="Annual Revenue"
                          value={formData.annualrevenue}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">No of Employees</label>
                        <input
                          type="number"
                          name="noofemployees"
                          placeholder="Employees"
                          value={formData.noofemployees}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="companylocation">
                          Company Location
                        </label>
                        <input
                          type="text"
                          name="companylocation"
                          placeholder="Company location"
                          value={formData.companylocation}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="designation">Headquarters</label>
                        <input
                          type="text"
                          name="headquarter"
                          placeholder="Head Quarter"
                          value={formData.headquarter}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Sub category</label>
                        <input
                          type="text"
                          name="subcategory"
                          placeholder="Sub category"
                          value={formData.subcategory}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Type of Customer</label>
                        <input
                          type="text"
                          name="typeofCustomer"
                          placeholder="Type of customer"
                          value={formData.typeofCustomer}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Financial</label>
                        {formData.financial.map((finance, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <button
                              type="button"
                              className="remove-button"
                              onClick={() => removeFinancialForm(index)}
                              style={{
                                alignSelf: "flex-end",
                                cursor: "pointer",
                                border: "none",
                              }}
                            >
                              X
                            </button>
                            <input
                              type="text"
                              name="financialdescription"
                              placeholder="Financial Description"
                              value={finance.financialdescription}
                              onChange={(e) =>
                                handleFinanceFormChange(
                                  e,
                                  index,
                                  "financialdescription"
                                )
                              }
                            />
                            <input
                              type="text"
                              name="financialyear"
                              placeholder="Financial Year"
                              value={finance.financialyear}
                              onChange={(e) =>
                                handleFinanceFormChange(
                                  e,
                                  index,
                                  "financialyear"
                                )
                              }
                            />
                            <input
                              type="text"
                              name="financialsourcelink"
                              placeholder="Financial"
                              value={finance.financialsourcelink}
                              onChange={(e) =>
                                handleFinanceFormChange(
                                  e,
                                  index,
                                  "financialsourcelink"
                                )
                              }
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addFinancialForm}
                        >
                          + Add More
                        </button>
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Investors</label>
                        {formData.investors.map((invest, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <button
                              type="button"
                              className="remove-button"
                              onClick={() => removeInvestorForm(index)}
                              style={{
                                alignSelf: "flex-end",
                                cursor: "pointer",
                                border: "none",
                              }}
                            >
                              X
                            </button>
                            <input
                              type="text"
                              name="investors"
                              placeholder="Investors"
                              value={invest.investors}
                              onChange={(e) =>
                                handleInvestorFormChange(e, index, "investors")
                              }
                            />
                            <input
                              type="text"
                              name="investors"
                              placeholder="Investors"
                              value={invest.investorsourcelink}
                              onChange={(e) =>
                                handleInvestorFormChange(
                                  e,
                                  index,
                                  "investorsourcelink"
                                )
                              }
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addInvestorForm}
                        >
                          + Add More
                        </button>
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Competitors</label>
                        <input
                          type="text"
                          name="competitors"
                          placeholder="competitors"
                          value={formData.competitors}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="partner">Partners</label>
                        <input
                          type="text"
                          name="partners"
                          placeholder="Partners"
                          value={formData.partners}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="technologydetails">
                          Technology Details
                          <span style={{ color: "red", margin: "0px 2px" }}>
                            *
                          </span>
                        </label>
                        <input
                          type="text"
                          name="technologydetails"
                          placeholder="Technology details"
                          value={formData.technologydetails}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="jobopenings">
                          Job Openings
                          <span style={{ color: "red", margin: "0px 2px" }}>
                            *
                          </span>
                        </label>
                        {formData.jobopenings.map((job, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            {formData.newsandsocialinsights.length > 1 && (
                              <button
                                type="button"
                                className="remove-button"
                                onClick={() => removeJobOpeningForm(index)}
                                style={{
                                  alignSelf: "flex-end",
                                  cursor: "pointer",
                                  border: "none",
                                }}
                              >
                                X
                              </button>
                            )}
                            <input
                              type="text"
                              name="jobname"
                              placeholder="Job Title"
                              value={job.jobname}
                              onChange={(e) =>
                                handleJobFormChange(e, index, "jobname")
                              }
                              required
                            />
                            <input
                              type="text"
                              name="jobdescription"
                              placeholder="Job Description"
                              value={job.jobdescription}
                              onChange={(e) =>
                                handleJobFormChange(e, index, "jobdescription")
                              }
                              required
                            />
                            <input
                              type="text"
                              name="jobsource"
                              placeholder="Job Link"
                              value={job.jobsource}
                              onChange={(e) =>
                                handleJobFormChange(e, index, "jobsource")
                              }
                              required
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addJobOpeningForm}
                        >
                          + Add More
                        </button>
                      </div>
                      <div className="input-container">
                        <label htmlFor="newsandsocialinsights">
                          News and Social Insights
                          <span style={{ color: "red", margin: "0px 2px" }}>
                            *
                          </span>
                        </label>
                        {formData.newsandsocialinsights.map((news, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            {formData.newsandsocialinsights.length > 1 && (
                              <button
                                type="button"
                                className="remove-button"
                                onClick={() => removeNewsForm(index)}
                                style={{
                                  alignSelf: "flex-end",
                                  cursor: "pointer",
                                  border: "none",
                                }}
                              >
                                X
                              </button>
                            )}
                            <input
                              type="text"
                              name="newsname"
                              placeholder="News Title"
                              value={news.newsname}
                              onChange={(e) =>
                                handleNewsFormChange(e, index, "newsname")
                              }
                              required
                            />
                            <input
                              type="text"
                              name="newsdescription"
                              placeholder="News Description"
                              value={news.newsdescription}
                              onChange={(e) =>
                                handleNewsFormChange(
                                  e,
                                  index,
                                  "newsdescription"
                                )
                              }
                              required
                            />
                            <input
                              type="text"
                              name="newssource"
                              placeholder="News Source"
                              value={news.newssource}
                              onChange={(e) =>
                                handleNewsFormChange(e, index, "newssource")
                              }
                              required
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addNewsForm}
                        >
                          + Add More
                        </button>
                      </div>
                    </div>
                    <div className="button-action">
                      <button
                        className="close-button"
                        onClick={() => setShowForm(false)}
                      >
                        Close
                      </button>
                      {role === "researcher" && (
                        <button className="add-button" type="submit">
                          Submit
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            )}

            {showMissingFieldsPopup && (
              <div className="popup-overlay">
                <div className="popup">
                  <h2>⚠️ Missing Required Fields</h2>
                  <p>The following required fields are missing:</p>
                  <ul>
                    {missingFields.map((field, index) => (
                      <li key={index}>{field}</li>
                    ))}
                  </ul>
                  <div className="popup-buttons-upload">
                    <button onClick={handleCancelUpload}>Cancel</button>
                    <button onClick={handleProceedUpload}>Proceed</button>
                  </div>
                </div>
              </div>
            )}

            {showPopup && (
              <div className="upload-popup">
                <div
                  className="popup-overlay"
                  onClick={() => setShowPopup(false)}
                >
                  <div
                    className="popup-grid"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
                      className="popup-close"
                      onClick={() => setShowPopup(false)}
                    >
                      X
                    </button>
                    <h2 className="revenuintel-matching">Revenuintel</h2>
                    {/* Table-like Matching Layout */}
                    <div className="matching-container">
                      {excelHeaders.map((uploadedHeader, index) => (
                        <div key={index} className="matching-row">
                          <span className="uploaded-header">
                            {uploadedHeader}
                          </span>
                          <span className="match-arrow">→</span>
                          <select
                            value={selectedFields[uploadedHeader] || ""}
                            onChange={(e) =>
                              handleMappingChange(
                                uploadedHeader,
                                e.target.value
                              )
                            }
                          >
                            <option value="">Select Header</option>
                            {requiredHeaders.map((requiredHeader, idx) => {
                              // Check if this header is already selected
                              const isSelected =
                                Object.values(selectedFields).includes(
                                  requiredHeader
                                );

                              return (
                                <option
                                  key={idx}
                                  value={requiredHeader}
                                  disabled={isSelected}
                                >
                                  {requiredHeader}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      ))}
                    </div>
                    <button
                      className="popup-submit"
                      onClick={handleCheckMissingFields}
                    >
                      Apply Mapping
                    </button>
                  </div>
                </div>
              </div>
            )}

            {(isAdd || editMode) && (
              <div className="add-popup">
                <div className="overlay" onClick={handleCloseOverlay}></div>
                <div className="add-popup-box">
                  <div className="add-heading">
                    <button
                      className="popup-close"
                      onClick={handleCloseOverlay}
                    >
                      X
                    </button>
                    {isAdd ? (
                      <h4>Add Contact Details</h4>
                    ) : editMode ? (
                      <h4>Edit Contact Details</h4>
                    ) : (
                      <h4>Add Contact Details</h4>
                    )}
                  </div>
                  <form className="form-container" onSubmit={handleSubmit}>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="name">First Name</label>
                        <input
                          type="text"
                          name="firstname"
                          placeholder="Enter name"
                          value={details.firstname}
                          onChange={handleOnChange}
                          required
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="name">Company Name</label>
                        <input
                          type="text"
                          name="companyname"
                          placeholder="Enter company name"
                          value={details.companyname}
                          onChange={handleOnChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="linkedin">Linkedin Link</label>
                        <input
                          type="text"
                          name="linkedin"
                          placeholder="Enter linkedin link"
                          value={details.linkedin}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="name">Email</label>
                        <input
                          type="email"
                          name="email"
                          placeholder="Enter email"
                          value={details.email}
                          onChange={handleOnChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Designation</label>
                        <input
                          type="text"
                          name="designation"
                          placeholder="Designation"
                          value={details.designation}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Phone Number</label>
                        <input
                          type="number"
                          name="phonenumber"
                          placeholder="Phone Number"
                          value={details.phonenumber}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="website">Website</label>
                        <input
                          type="text"
                          name="website"
                          placeholder="Website Link"
                          value={details.website}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="designation">Company description</label>
                        <textarea
                          type="text"
                          name="companydescription"
                          placeholder="Company Description"
                          value={details.companydescription}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">City</label>
                        <input
                          type="text"
                          name="city"
                          placeholder="City"
                          value={details.city}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">State</label>
                        <input
                          type="text"
                          name="state"
                          placeholder="State"
                          value={details.state}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="country">Country</label>
                        <input
                          type="text"
                          name="country"
                          placeholder="Country"
                          value={details.country}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Industry</label>
                        <input
                          type="text"
                          name="industry"
                          placeholder="Industry"
                          value={details.industry}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Annual Revenue</label>
                        <input
                          type="text"
                          name="annualrevenue"
                          placeholder="Annual Revenue"
                          value={details.annualrevenue}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">No of Employees</label>
                        <input
                          type="number"
                          name="noofemployees"
                          placeholder="Employees"
                          value={details.noofemployees}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="companylocation">
                          Company Location
                        </label>
                        <input
                          type="text"
                          name="companylocation"
                          placeholder="Company location"
                          value={details.companylocation}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="designation">Headquarters</label>
                        <input
                          type="text"
                          name="headquarter"
                          placeholder="Head Quarter"
                          value={details.headquarter}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="subcategory">Sub category</label>
                        <input
                          type="text"
                          name="subcategory"
                          placeholder="Sub category"
                          value={details.subcategory}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="typeofcustomer">Type of Customer</label>
                        <input
                          type="text"
                          name="typeofCustomer"
                          placeholder="Type of customer"
                          value={details.typeofCustomer}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="financial">Financial</label>
                        {details.financial.map((finance, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <button
                              type="button"
                              className="remove-button"
                              onClick={() => removeFinancial(index)}
                              style={{
                                alignSelf: "flex-end",
                                cursor: "pointer",
                                border: "none",
                              }}
                            >
                              X
                            </button>
                            <input
                              type="text"
                              name="financialdescription"
                              placeholder="Financial"
                              value={finance.financialdescription}
                              onChange={(e) =>
                                handleFinanceChange(
                                  e,
                                  index,
                                  "financialdescription"
                                )
                              }
                            />
                            <input
                              type="text"
                              name="financialyear"
                              placeholder="Financial Year"
                              value={finance.financialyear}
                              onChange={(e) =>
                                handleFinanceChange(e, index, "financialyear")
                              }
                            />
                            <input
                              type="text"
                              name="financialsourcelink"
                              placeholder="Financial Source Link"
                              value={finance.financialsourcelink}
                              onChange={(e) =>
                                handleFinanceChange(
                                  e,
                                  index,
                                  "financialsourcelink"
                                )
                              }
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addFinancial}
                        >
                          + Add More
                        </button>
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Investors</label>
                        {details.investors.map((invest, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <button
                              type="button"
                              className="remove-button"
                              onClick={() => removeInvestor(index)}
                              style={{
                                alignSelf: "flex-end",
                                cursor: "pointer",
                                border: "none",
                              }}
                            >
                              X
                            </button>
                            <input
                              type="text"
                              name="investors"
                              placeholder="Investors"
                              value={invest.investors}
                              onChange={(e) =>
                                handleInvestorChange(e, index, "investors")
                              }
                            />
                            <input
                              type="text"
                              name="investors"
                              placeholder="Investors"
                              value={invest.investorsourcelink}
                              onChange={(e) =>
                                handleInvestorChange(
                                  e,
                                  index,
                                  "investorsourcelink"
                                )
                              }
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addInvestor}
                        >
                          + Add More
                        </button>
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Competitors</label>
                        <input
                          type="text"
                          name="competitors"
                          placeholder="competitors"
                          value={details.competitors}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="partner">Partners</label>
                        <input
                          type="text"
                          name="partners"
                          placeholder="Partners"
                          value={details.partners}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="followers">Followers</label>
                        <input
                          type="text"
                          name="followers"
                          placeholder="Followers"
                          value={details.followers}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="technologydetails">
                          Technology Details
                        </label>
                        <input
                          type="text"
                          name="technologydetails"
                          placeholder="Technology Details"
                          value={details.technologydetails}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="jobopenings">Job Openings</label>
                        {details.jobopenings.map((job, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <button
                              type="button"
                              className="remove-button"
                              onClick={() => removeJobOpening(index)}
                              style={{
                                alignSelf: "flex-end",
                                cursor: "pointer",
                                border: "none",
                              }}
                            >
                              X
                            </button>
                            <input
                              type="text"
                              name="jobname"
                              placeholder="Job Title"
                              value={job.jobname}
                              onChange={(e) =>
                                handleJobChange(e, index, "jobname")
                              }
                            />
                            <input
                              type="text"
                              name="jobdescription"
                              placeholder="Job Description"
                              value={job.jobdescription}
                              onChange={(e) =>
                                handleJobChange(e, index, "jobdescription")
                              }
                            />
                            <input
                              type="text"
                              name="jobsource"
                              placeholder="Job Link"
                              value={job.jobsource}
                              onChange={(e) =>
                                handleJobChange(e, index, "jobsource")
                              }
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addJobOpening}
                        >
                          + Add More
                        </button>
                      </div>
                      <div className="input-container">
                        <label htmlFor="newsandsocialinsights">
                          News and Social Insights
                        </label>
                        {details.newsandsocialinsights.map((news, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <button
                              type="button"
                              className="remove-button"
                              onClick={() => removeNews(index)}
                              style={{
                                alignSelf: "flex-end",
                                cursor: "pointer",
                                border: "none",
                              }}
                            >
                              X
                            </button>
                            <input
                              type="text"
                              name="newsname"
                              placeholder="News Title"
                              value={news.newsname}
                              onChange={(e) =>
                                handleNewsChange(e, index, "newsname")
                              }
                            />
                            <input
                              type="text"
                              name="newsdescription"
                              placeholder="News Description"
                              value={news.newsdescription}
                              onChange={(e) =>
                                handleNewsChange(e, index, "newsdescription")
                              }
                            />
                            <input
                              type="text"
                              name="newssource"
                              placeholder="News Source"
                              value={news.newssource}
                              onChange={(e) =>
                                handleNewsChange(e, index, "newssource")
                              }
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addNews}
                        >
                          + Add More
                        </button>
                      </div>
                    </div>
                    <div className="button-action">
                      <button
                        className="close-button"
                        onClick={handleCloseOverlay}
                      >
                        Close
                      </button>
                      <button className="add-button" type="submit">
                        {editMode ? "Update" : "Add"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {showlist && (
              <div className="popup-overlay">
                <div className="popup-box">
                  <h2>Create List</h2>
                  <input
                    className="create-input"
                    type="text"
                    value={listName}
                    onChange={(e) => setListName(e.target.value)}
                    placeholder="Enter list name"
                  />
                  <button onClick={handleSave} className="create-save-btn">
                    Save
                  </button>
                  <button
                    onClick={() => setShowlist(false)}
                    className="cancel-btn"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}

            {isResearch && (
              <div className="add-popup">
                <div
                  className="overlay"
                  onClick={() => {
                    setIsResearch(false);
                  }}
                ></div>
                <div className="add-popup-box">
                  <div className="add-heading">
                    <button
                      className="popup-close"
                      onClick={() => setIsResearch(false)}
                    >
                      X
                    </button>
                    <h4>Add Fields for Research</h4>
                  </div>
                  <form
                    className="form-container"
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (role === "researcher") {
                        handleSubmitResearch(e);
                      } else if (role === "admin") {
                        handleApproveResearch(
                          research.userId,
                          research.matchId
                        );
                      } else if (role === "user") {
                        handleSendResearch(e);
                      }
                    }}
                  >
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="name">First Name</label>
                        <input
                          type="text"
                          name="firstname"
                          placeholder="Enter name"
                          value={research.firstname}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="name">Company Name</label>
                        <input
                          type="text"
                          name="companyname"
                          placeholder="Enter company name"
                          value={research.companyname}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="linkedin">Linkedin Link</label>
                        <input
                          type="text"
                          name="linkedin"
                          placeholder="Enter linkedin link"
                          value={research.linkedin}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="name">Email</label>
                        <input
                          type="email"
                          name="email"
                          placeholder="Enter email"
                          value={research.email}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Designation</label>
                        <input
                          type="text"
                          name="designation"
                          placeholder="Designation"
                          value={research.designation}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Phone Number</label>
                        <input
                          type="number"
                          name="phonenumber"
                          placeholder="Phone Number"
                          value={research.phonenumber}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="website">Website</label>
                        <input
                          type="text"
                          name="website"
                          placeholder="Website Link"
                          value={research.website}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="designation">Company description</label>
                        <textarea
                          type="text"
                          name="companydescription"
                          placeholder="Company Description"
                          value={research.companydescription}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">City</label>
                        <input
                          type="text"
                          name="city"
                          placeholder="City"
                          value={research.city}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">State</label>
                        <input
                          type="text"
                          name="state"
                          placeholder="State"
                          value={research.state}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="country">Country</label>
                        <input
                          type="text"
                          name="country"
                          placeholder="Country"
                          value={research.country}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Industry</label>
                        <input
                          type="text"
                          name="industry"
                          placeholder="Industry"
                          value={research.industry}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Annual Revenue</label>
                        <input
                          type="text"
                          name="annualrevenue"
                          placeholder="Annual Revenue"
                          value={research.annualrevenue}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">No of Employees</label>
                        <input
                          type="number"
                          name="noofemployees"
                          placeholder="Employees"
                          value={research.noofemployees}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="companylocation">
                          Company Location
                        </label>
                        <input
                          type="text"
                          name="companylocation"
                          placeholder="Company location"
                          value={research.companylocation}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="designation">Headquarters</label>
                        <input
                          type="text"
                          name="headquarter"
                          placeholder="Head Quarter"
                          value={research.headquarter}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Sub category</label>
                        <input
                          type="text"
                          name="subcategory"
                          placeholder="Sub category"
                          value={research.subcategory}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Type of Customer</label>
                        <input
                          type="text"
                          name="typeofCustomer"
                          placeholder="Type of customer"
                          value={research.typeofCustomer}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Financial</label>
                        {research?.financial?.map((finance, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <br />
                            <input
                              type="text"
                              name="financialdescription"
                              placeholder="Financial"
                              value={finance.financialdescription}
                              onChange={(e) =>
                                handleFinanceChange(
                                  e,
                                  index,
                                  "financialdescription"
                                )
                              }
                            />
                            <input
                              type="text"
                              name="financialyear"
                              placeholder="Financial Description"
                              value={finance.financialyear}
                              onChange={(e) =>
                                handleFinanceChange(e, index, "financialyear")
                              }
                            />
                            <input
                              type="text"
                              name="financialsourcelink"
                              placeholder="Financial Year"
                              value={finance.financialsourcelink}
                              onChange={(e) =>
                                handleFinanceChange(
                                  e,
                                  index,
                                  "financialsourcelink"
                                )
                              }
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addFinancial}
                        >
                          + Add More
                        </button>
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Investors</label>
                        {research?.investors?.map((invest, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <br />
                            <input
                              type="text"
                              name="investors"
                              placeholder="Investors"
                              value={invest.investors}
                              onChange={(e) =>
                                handleInvestorChange(e, index, "investors")
                              }
                            />
                            <input
                              type="text"
                              name="investors"
                              placeholder="Investors"
                              value={invest.investorsourcelink}
                              onChange={(e) =>
                                handleInvestorChange(
                                  e,
                                  index,
                                  "investorsourcelink"
                                )
                              }
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addInvestor}
                        >
                          + Add More
                        </button>
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Competitors</label>
                        <input
                          type="text"
                          name="competitors"
                          placeholder="competitors"
                          value={research.competitors}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="partner">Partners</label>
                        <input
                          type="text"
                          name="partners"
                          placeholder="Partners"
                          value={research.partners}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="followers">Followers</label>
                        <input
                          type="text"
                          name="followers"
                          placeholder="Followers"
                          value={research.followers}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="technologydetails">
                          Technology Details
                        </label>
                        <input
                          type="text"
                          name="technologydetails"
                          placeholder="Technology details"
                          value={research.technologydetails}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="jobopenings">Job Openings</label>
                        {research?.jobopenings?.map((job, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <br />
                            <input
                              type="text"
                              name="jobname"
                              placeholder="Job Title"
                              value={job.jobname}
                              onChange={(e) =>
                                handleJobChange(e, index, "jobname")
                              }
                            />
                            <input
                              type="text"
                              name="jobdescription"
                              placeholder="Job Description"
                              value={job.jobdescription}
                              onChange={(e) =>
                                handleJobChange(e, index, "jobdescription")
                              }
                            />
                            <input
                              type="text"
                              name="jobsource"
                              placeholder="Job Link"
                              value={job.jobsource}
                              onChange={(e) =>
                                handleJobChange(e, index, "jobsource")
                              }
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addJobOpening}
                        >
                          + Add More
                        </button>
                      </div>
                      <div className="input-container">
                        <label htmlFor="newsandsocialinsights">
                          News and Social Insights
                        </label>
                        {research?.newsandsocialinsights?.map((news, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <br />
                            <input
                              type="text"
                              name="newsname"
                              placeholder="News Title"
                              value={news.newsname}
                              onChange={(e) =>
                                handleNewsChange(e, index, "newsname")
                              }
                            />
                            <input
                              type="text"
                              name="newsdescription"
                              placeholder="News Description"
                              value={news.newsdescription}
                              onChange={(e) =>
                                handleNewsChange(e, index, "newsdescription")
                              }
                            />
                            <input
                              type="text"
                              name="newssource"
                              placeholder="News Source"
                              value={news.newssource}
                              onChange={(e) =>
                                handleNewsChange(e, index, "newssource")
                              }
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addNews}
                        >
                          + Add More
                        </button>
                      </div>
                    </div>

                    {/* Input for field label (only shows when Add Field is clicked) */}
                    {showLabelInput && (
                      <div className="input-container">
                        <input
                          type="text"
                          placeholder="Enter Field Label"
                          value={newFieldLabel}
                          onChange={(e) => setNewFieldLabel(e.target.value)}
                          onKeyDown={handleLabelSubmit}
                          autoFocus
                        />
                      </div>
                    )}
                    {research.extraFields?.length > 0 &&
                      research.extraFields.map((field, index) => (
                        <div key={index}>
                          {/* <button onClick={() => handleRemoveField(index)}>X</button> */}
                          <label>{field.label}</label>
                          <input
                            type="text"
                            value={field.value || ""}
                            onChange={(e) => handleFieldValueChange(e, index)}
                          />
                        </div>
                      ))}

                    <div className="button-action">
                      {role === "user" && (
                        <button
                          className="add-field"
                          type="button"
                          onClick={() => setShowLabelInput(true)}
                        >
                          Add Field
                        </button>
                      )}
                      <button className="add-button" type="submit">
                        {role === "researcher"
                          ? "Submit"
                          : role === "admin"
                          ? "Approve"
                          : "Send"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {isOpenProfile && (
              <div className="profile-popup">
                <div
                  className="overlay"
                  onClick={() => setIsOpenProfile(false)}
                ></div>
                <div className="profile-popup-box">
                  {paginatedData
                    .filter((item) => item._id === selectedItem?._id)
                    .map((item, index) => (
                      <div key={index}>
                        <div className="profile-box">
                          <div className="profile-container">
                            <div className="dwld-heart"></div>
                            <div className="profile-image">
                              <div className="profile-image-tick">
                                {selectedItem.profileImage ? (
                                  <img src={EmptyImage} alt="Profile" />
                                ) : (
                                  <img src={EmptyImage} alt="default pic" />
                                )}
                                {visibleColumns.image &&
                                  visibleColumns.status && (
                                    <span className="active-icon">
                                      {item.status === "Active" ? (
                                        <VscPass
                                          className={getStatusprofile(
                                            item.status
                                          )}
                                        />
                                      ) : (
                                        <VscError
                                          className={getStatusprofile(
                                            item.status
                                          )}
                                        />
                                      )}
                                    </span>
                                  )}
                              </div>
                            </div>
                            <div
                              className="dwld-btn"
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "start",
                                gap: "25px",
                                marginLeft: "0",
                                marginRight: "40px",
                              }}
                            >
                              <button
                                onClick={() =>
                                  handleOpenEmailCampaign(item._id)
                                }
                              >
                                <img src={mail} alt="mail" width="25px" />
                              </button>
                              <button onClick={() => downloadPDF(item._id)}>
                                <img
                                  src={download}
                                  alt="download"
                                  width="25px"
                                />
                              </button>
                              <button onClick={handleCloseProfile}>
                                <img
                                  src={cross}
                                  alt="cross"
                                  width="25px"
                                  height="25px"
                                />
                              </button>
                            </div>
                          </div>
                          <div className="profile-name">
                            {visibleColumns.firstname && (
                              <p
                                style={{
                                  textAlign: "center",
                                  marginRight: "35px",
                                }}
                              >
                                {item.firstname}
                              </p>
                            )}
                          </div>
                          <div className="profile-role">
                            {visibleColumns.designation && (
                              <p style={{ textAlign: "center" }}>
                                {item.designation}
                                <span> @ {item.companyname}</span>
                              </p>
                            )}
                          </div>
                        </div>
                        <img
                          src={line}
                          alt="line"
                          style={{ marginLeft: "100px" }}
                        />
                        <div className="profile-inside-container">
                          <div className="company-info">
                            <button
                              style={{
                                backgroundColor: companyColor,
                                color:
                                  companyColor === "#FCB124"
                                    ? "#fff"
                                    : "#000000",

                                fontWeight: "500",
                              }}
                              onClick={handleShowCompany}
                            >
                              Company Overview
                            </button>
                          </div>
                          <div className="profile-info">
                            <button
                              style={{
                                backgroundColor: techColor,
                                color:
                                  techColor === "#FCB124" ? "#fff" : "#000000",
                              }}
                              onClick={handleShowTechStack}
                            >
                              Technographics
                            </button>
                          </div>
                          <div className="profile-info">
                            <button
                              style={{
                                backgroundColor: contactColor,
                                color:
                                  contactColor === "#FCB124"
                                    ? "#fff"
                                    : "#000000",
                              }}
                              onClick={handleShowContact}
                            >
                              Decision Makers
                            </button>
                          </div>
                        </div>
                        <div
                          className="profile-inside-container"
                          style={{ marginTop: "20px" }}
                        >
                          <div className="openings-info">
                            <button
                              style={{
                                backgroundColor: jobColor,
                                color:
                                  jobColor === "#FCB124" ? "#fff" : "#000000",
                              }}
                              onClick={handleShowOpenings}
                            >
                              Job Openings
                            </button>
                          </div>
                          <div className="openings-info">
                            <button
                              style={{
                                backgroundColor: accountColor,
                                color:
                                  accountColor === "#FCB124"
                                    ? "#fff"
                                    : "#000000",
                              }}
                              onClick={handleShowAccount}
                            >
                              News & Social Insights
                            </button>
                          </div>
                        </div>
                        {showCompany && (
                          <div className="company-details">
                            <div className="company-heading"></div>
                            <div className="company-overview">
                              {item.companyname && (
                                <li className="info-row">
                                  <span className="label">
                                    🏢 <strong>Company Name</strong>
                                  </span>
                                  <span className="colon">:</span>
                                  <span className="value">
                                    {item.companyname}
                                  </span>
                                </li>
                              )}
                              {item.companydescription && (
                                <li className="info-row">
                                  <span className="label">
                                    📝 <strong>Description</strong>{" "}
                                  </span>
                                  <span className="colon">:</span>
                                  <span className="value">
                                    {item.companydescription
                                      .split(" ")
                                      .slice(0, 20)
                                      .join(" ")}
                                    {item.companydescription.split(" ").length >
                                      50 && "..."}
                                  </span>
                                </li>
                              )}

                              {item.website && (
                                <li className="info-row">
                                  <span className="label">
                                    🌐 <strong>Website</strong>{" "}
                                  </span>
                                  <span className="colon">:</span>
                                  <span className="value">
                                    <a
                                      href={item.website}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item.website}
                                    </a>
                                  </span>
                                </li>
                              )}
                              {item.headquarter && (
                                <li className="info-row">
                                  <span className="label">
                                    {" "}
                                    📍 <strong>Headquarters</strong>{" "}
                                  </span>
                                  <span className="colon">:</span>
                                  <span className="value">
                                    {" "}
                                    {item.headquarter}
                                  </span>
                                </li>
                              )}
                              {item.industry && (
                                <li className="info-row">
                                  <span className="label">
                                    {" "}
                                    🏭 <strong>Industry</strong>{" "}
                                  </span>
                                  <span className="colon">:</span>
                                  <span className="value">
                                    {" "}
                                    {item.industry}
                                  </span>
                                </li>
                              )}
                              {item.noofemployees && (
                                <li className="info-row">
                                  <span className="label">
                                    👥 <strong>Employees</strong>
                                  </span>
                                  <span className="colon">:</span>
                                  <span className="value">
                                    {item.noofemployees}
                                  </span>
                                </li>
                              )}

                              {item.annualrevenue && (
                                <li className="info-row">
                                  <span className="label">
                                    {" "}
                                    💰 <strong>Revenue</strong>{" "}
                                  </span>
                                  <span className="colon">:</span>
                                  <span className="value">
                                    {item.annualrevenue}
                                  </span>
                                </li>
                              )}
                            </div>
                          </div>
                        )}

                        {showTechstack && (
                          <div>
                            <div className="tech-heading">
                              <h3 style={{ marginTop: "30px" }}>
                                💻 <strong>Technology Details</strong>
                              </h3>
                            </div>
                            <div
                              className="tech-overview"
                              style={{
                                textAlign: "justify",
                                lineHeight: "20px",
                                width: "580px",
                                marginLeft: "80px",
                              }}
                            >
                              {item.technologydetails && (
                                <span className="tech-text">
                                  {item.technologydetails}
                                </span>
                              )}
                            </div>
                          </div>
                        )}

                        {showContact && (
                          <div className="company-details">
                            <div className="company-heading">
                              <h3
                                style={{
                                  marginLeft: "216px",
                                  marginTop: "25px",
                                }}
                              >
                                {/* <img src={key} alt="key" width="15px" height="15px" style={{paddingTop:"5px"}} /> */}
                                <FaUserTie />{" "}
                                <strong>Key Decision Makers</strong>{" "}
                              </h3>
                            </div>
                            <div
                              className="company-overview"
                              style={{
                                marginLeft: "150px",
                                lineHeight: "20px",
                              }}
                            >
                              {(() => {
                                const sameCompany = paginatedData.filter(
                                  (contact) =>
                                    contact.companyname ===
                                    selectedItem.companyname
                                );

                                const decisionMakers = sameCompany.filter(
                                  (contact) =>
                                    [
                                      "chief executive officer",
                                      "ceo",
                                      "chief financial officer",
                                      "cfo",
                                      "cto",
                                      "cmo",
                                      "chief technology officer",
                                      "vp engineering",
                                    ].includes(
                                      contact.designation?.toLowerCase()
                                    )
                                );

                                return decisionMakers.length > 0 ? (
                                  decisionMakers.map((contact, index) => (
                                    <li
                                      style={{ marginLeft: "30px" }}
                                      key={index}
                                    >
                                      👤 {contact.firstname} -{" "}
                                      {contact.designation}
                                    </li>
                                  ))
                                ) : (
                                  <p style={{ marginLeft: "170px" }}>
                                    Not Available
                                  </p>
                                );
                              })()}
                            </div>
                          </div>
                        )}

                        {showAccount && (
                          <div className="company-details">
                            <div className="company-heading">
                              <h3 style={{ marginLeft: "216px" }}>
                                📰 News & Social Insights
                              </h3>
                            </div>
                            <div
                              style={{
                                marginLeft: "30px",
                                lineHeight: "20px",
                                marginTop: "0",
                              }}
                            >
                              {item.newsandsocialinsights.length === 0 ? (
                                <div>
                                  <span>No News available</span>
                                </div>
                              ) : (
                                item.newsandsocialinsights?.map(
                                  (news, index) => {
                                    const isExpandedNews =
                                      expandedNewsIndex === index;

                                    // Truncate description if not expanded
                                    const displayText = isExpandedNews
                                      ? news.newsdescription
                                      : news.newsdescription.slice(0, 150) +
                                        "...";
                                    return (
                                      <div
                                        style={{ padding: "5px" }}
                                        className="news-item"
                                        key={index}
                                      >
                                        <h4
                                          style={{
                                            fontSize: "14px",
                                            margin: "0px",
                                          }}
                                        >
                                          {news.newsname}
                                        </h4>
                                        <p
                                          style={{
                                            fontSize: "14px",
                                            width: "550px",
                                            lineHeight: "20px",
                                            textAlign: "justify",
                                          }}
                                        >
                                          {displayText}
                                          {news.newsdescription.length >
                                            100 && (
                                            <span
                                              style={{
                                                color: "blue",
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                setExpandedNewsIndex(
                                                  isExpandedNews ? null : index
                                                )
                                              }
                                            >
                                              {isExpandedNews
                                                ? "Read Less"
                                                : "Read More"}
                                            </span>
                                          )}
                                        </p>
                                        <div
                                          style={{
                                            fontSize: "12px",
                                            marginLeft: "0px",
                                            marginTop: "0",
                                          }}
                                        >
                                          Updated:{" "}
                                          {new Date(
                                            item.createdAt
                                          ).toLocaleDateString()}
                                          &nbsp;{"|"}&nbsp;
                                          {new Date(
                                            item.createdAt
                                          ).toLocaleTimeString()}
                                          <span
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {news.newssource}
                                          </span>
                                        </div>
                                      </div>
                                    );
                                  }
                                )
                              )}

                              {item.newsandsocialinsights.length > 1 && (
                                <button
                                  style={{
                                    backgroundColor: "#FCB124",
                                    border: "none",
                                    width: "150px",
                                    height: "30px",
                                    margin: "auto",
                                    top: "20px",
                                  }}
                                  className="show-more-btn"
                                  onClick={handleShowMoreNews}
                                >
                                  Show More News
                                </button>
                              )}
                            </div>
                          </div>
                        )}

                        {showOpenings && (
                          <div style={{ paddingBottom: "30px" }}>
                            <div className="company-heading">
                              <h3
                                style={{
                                  textAlign: "center",
                                  marginTop: "30px",
                                }}
                              >
                                {/* <img src={job} alt="job" width="15px" height="15px" style={{paddingTop:"12px", paddingLeft:"10px"}}/>  */}
                                <FaClipboardList />{" "}
                                <strong>Job Openings</strong>
                              </h3>
                            </div>
                            {item.jobopenings.length === 0 ? (
                              <div>
                                <span>No Jobs available</span>
                              </div>
                            ) : (
                              item.jobopenings.map((job, index) => {
                                const isExpandedJob =
                                  expandedJobIndex === index;

                                const displayText = isExpandedJob
                                  ? job.jobdescription
                                  : job.jobdescription.slice(0, 150) + "...";
                                return (
                                  <div className="job-details">
                                    <div
                                      className="job-container"
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "start",
                                        justifyContent: "space-between",
                                        gap: "10px",
                                      }}
                                    >
                                      <div key={index}>
                                        {job.jobname && (
                                          <h3
                                            className="job-title"
                                            style={{ fontWeight: "400" }}
                                          >
                                            {job.jobname}
                                          </h3>
                                        )}
                                        {job.jobdescription && (
                                          <p className="company-name">
                                            🏢 {displayText}
                                            {job.jobdescription.length >
                                              100 && (
                                              <span
                                                style={{
                                                  color: "blue",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  setExpandedJobIndex(
                                                    isExpandedJob ? null : index
                                                  )
                                                }
                                              >
                                                {isExpandedJob
                                                  ? "Read Less"
                                                  : "Read More"}
                                              </span>
                                            )}
                                          </p>
                                        )}
                                      </div>
                                      <div>
                                        {job.jobsource && (
                                          <p
                                            className="company-location"
                                            style={{
                                              color: "#000",
                                              cursor: "pointer",
                                            }}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {" "}
                                            <a
                                              href={job?.jobsource}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              <IoMdLink
                                                style={{
                                                  fontSize: "25px",
                                                  color: "#000",
                                                }}
                                              />
                                            </a>
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            )}
                            {item.jobopenings.length > 3 && (
                              <div className="show-more">
                                <a href="#s">show more</a>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MyContacts;
